// import React, { useEffect, useState, useCallback } from "react";

// import Navbar from "../components/Navbar";
// import Header from "./Header";
// // import "./Header.css";
// import "./MyBookings.css";

// import moment from "moment";

// import { Link, useNavigate } from "react-router-dom";
// import host from "../config";
// const RIbookings = () => {
//   const navigate = useNavigate();

//   // let host = "https://api.vmrdarental.com";
//   // let host = "https://api.vmrdarental.com";
//   const [paginatedBookingList, setPaginatedBookingList] = useState([]);

//   const [noData, setNoData] = useState();
//   const [bookingData, setBookingData] = useState([]);
//   const [bookingList, setBookingList] = useState([]);
//   const [statusCheck, setStatusCheck] = useState(false);
//   const [isShow, invokeModal] = React.useState(false);
//   const [editableRoom, setEditableRoom] = React.useState({});

//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 20;
//   const [showPopup, setShowPopup] = useState(false);
//   // const [cancellationReason, setCancellationReason] = useState("");
//   // const [selectedBooking, setSelectedBooking] = useState(null);
//   const [showModal, setShowModal] = useState(false);
//   const [cancellationReason, setCancellationReason] = useState("");
//   const [selectedBooking, setSelectedBooking] = useState(null);
//   const [refundReason, setRefundReason] = useState("");
//   const [selectedRI, setSelectedRI] = useState(""); // Stores selected RI value
//   const [selectedBookingId, setSelectedBookingId] = useState(null); // Stores the booking ID
//   const [showDiscountModal, setShowDiscountModal] = useState(false);
//   // const [selectedBooking, setSelectedBooking] = useState(null);
//   const [discountPercentage, setDiscountPercentage] = useState("");
//   const [discountReason, setDiscountReason] = useState("");

//   const [isModalOpen, setIsModalOpen] = useState(false);
//   //  const [selectedBooking, setSelectedBooking] = useState(null);
//   const [isChecked, setIsChecked] = useState(false);
//   const [damagedFile, setDamagedFile] = useState(null);
//   const [electricityBill, setElectricityBill] = useState(null);

//   const openModal = (booking) => {
//     setSelectedBooking(booking);
//     setIsModalOpen(true);
//   };

//   const closeModal = () => {
//     setIsModalOpen(false);
//     setSelectedBooking(null);
//     setIsChecked(false);
//   };

//   const openDiscountModal = (booking) => {
//     setSelectedBooking(booking);
//     setDiscountPercentage("");
//     setDiscountReason("");
//     setShowDiscountModal(true);
//   };

//   const openPopup = (bookingGroupId) => {
//     setSelectedBookingId(bookingGroupId); // Store the ID for API call
//     setShowPopup(true);
//   };

//   const closePopup = () => {
//     setShowPopup(false);
//     setSelectedRI(""); // Reset selection
//   };

//   const [showRemarksPopup, setShowRemarksPopup] = useState(false);
//   const [showStatusPopup, setShowStatusPopup] = useState(false);
//   // const [selectedBooking, setSelectedBooking] = useState(null);
//   const [remarks, setRemarks] = useState("");
//   const [attachment, setAttachment] = useState(null);
//   const [eventStatus, setEventStatus] = useState("");
//   const [discountFile, setDiscountFile] = useState("");
// const [isDiscountApplicable, setIsDiscountApplicable] = useState("");
// const [discountRemarks, setDiscountRemarks] = useState("");



//   const handleFileChange = async (e, fileType) => {
//     const file = e.target.files[0];
//     if (!file) return;

//     const formData = new FormData();
//     formData.append("image", file); // Key should match backend (upload.single('image'))
//     formData.append("fileType", fileType);

//     try {
//       const response = await fetch(`${host}/upload`, {
//         method: "POST",
//         body: formData,
//       });

//       if (!response.ok) {
//         throw new Error("Upload failed");
//       }

//       const result = await response.json();

//       if (result.location) {
//         // ✅ Fix: Use "location" instead of "fileUrl"
//         if (fileType === "damagedFile") {
//           setDamagedFile(result.location); // ✅ Fix: Store the correct URL
//           localStorage.setItem("damagedFile", result.location);
//         } else if (fileType === "electricityBill") {
//           setElectricityBill(result.location);
//           localStorage.setItem("electricityBill", result.location);
//         } else if (fileType === "discountFile") {
//           setDiscountFile(result.location);
//           localStorage.setItem("discountFile", result.location);
//         }
//         alert(`File uploaded successfully`);
//       } else {
//         throw new Error("Invalid file URL from server");
//       }
//     } catch (error) {
//       console.error(`Error uploading ${fileType}:`, error);
//       alert(`Error uploading ${fileType}`);
//     }
//   };

//   const openRemarksPopup = (booking) => {
//     setSelectedBooking(booking);
//     setRemarks(booking.remarks || "");
//     setShowRemarksPopup(true);
//   };

//   const openStatusPopup = (booking) => {
//     setSelectedBooking(booking);
//     setEventStatus(booking.event_status || "");
//     setShowStatusPopup(true);
//   };

//   const handleRemarksSubmit = async () => {
//     if (!remarks.trim()) {
//       alert("Remarks cannot be empty!");
//       return;
//     }

//     if (!isChecked) {
//       alert("Please confirm the information before submitting.");
//       return;
//     }

//     const userRole = localStorage.getItem("userRole");

//     // ✅ Retrieve the correctly stored file URLs
//     const damagedFileUrl = localStorage.getItem("damagedFile") || "";
//     const electricityBillUrl = localStorage.getItem("electricityBill") || "";
//     const discountFileUrl = localStorage.getItem("discountFile") || "";

//     const payload = {
//       booking_group_id: selectedBooking.booking_group_id,
//       remark: remarks,
//       added_by: userRole,
//       action: "approved",
//       attadamagedAttachment: damagedFileUrl, // ✅ Fix: Send correct URL
//       electricityAttachment: electricityBillUrl, // ✅ Fix: Send correct URL
//       discountAttachment: discountFileUrl,
//           discount_applicable: isDiscountApplicable || "No",
//     discount_remarks: discountRemarks || "",
//     };

//     console.log("Submitting Payload:", payload); // Debugging

//     try {
//       const response = await fetch(`${host}/update-post-booking-details`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(payload),
//       });

//       const result = await response.json();
//       if (response.ok) {
//         alert(result.message);
//         localStorage.removeItem("damagedFile"); // ✅ Clear after submission
//         localStorage.removeItem("electricityBill");
//         localStorage.removeItem("discountFile");
//         setShowRemarksPopup(false);
//         window.location.reload();
//       } else {
//         alert("Failed to submit remarks: " + result.message);
//       }
//     } catch (error) {
//       console.error("Error submitting remarks:", error);
//       alert("An error occurred. Please try again.");
//     }
//   };

//   const handleStatusSubmit = () => {
//     console.log("Event Status Updated:", eventStatus);
//     console.log("Attachment:", attachment);
//     setShowStatusPopup(false);
//   };

//   const handleApproval = async () => {
//     if (!selectedRI) {
//       alert("Please select an RI value before approving.");
//       return;
//     }

//     try {
//       console.log(" Sending request:", selectedBookingId, selectedRI);

//       const response = await fetch(`${host}/approveBooking`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: "Bearer " + localStorage.getItem("access_token"),
//         },
//         body: JSON.stringify({
//           booking_group_id: selectedBookingId,
//           ri_value: selectedRI,
//         }),
//       });

//       console.log("⏳ Waiting for response...");

//       if (!response.ok) {
//         throw new Error("Failed to approve booking");
//       }

//       const updatedBooking = await response.json();
//       console.log("✅ API Response:", updatedBooking);

//       if (updatedBooking.success) {
//         alert("Venue successfully approved!");
//         myBookingsList();
//         closePopup(); // Close modal
//       } else {
//         throw new Error("Approval failed");
//       }
//     } catch (error) {
//       console.error("❌ Error approving booking:", error);
//     }
//   };

//   const handleCancelClick = (booking) => {
//     const cancellationReason = prompt("Please enter a cancellation reason:");

//     if (!cancellationReason) {
//       alert("Cancellation reason is required.");
//       return;
//     }

//     cancelBooking(
//       booking.booking_group_id,
//       booking.date,
//       cancellationReason
//     ).then((success) => {
//       if (success) {
//         // Update UI only when the cancellation is successful
//         setPaginatedBookingList((prevList) =>
//           prevList.map((b) =>
//             b.booking_group_id === booking.booking_group_id
//               ? {
//                   ...b,
//                   status: "2",
//                   cancelDisabled: true,
//                   cancellation_reason: cancellationReason,
//                 }
//               : b
//           )
//         );
//       }
//     });
//   };

//   const cancelBooking = async (
//     bookingGroupId,
//     bookingDate,
//     cancellationReason
//   ) => {
//     let userRole = localStorage.getItem("userRole");

//     if (!userRole) {
//       console.error("User type not found in localStorage");
//       alert("User type not found. Please log in again.");
//       return false;
//     }

//     userRole = parseInt(userRole, 10);

//     console.log("Cancel Booking Request:", {
//       bookingGroupId,
//       bookingDate,
//       cancellationReason,
//       userRole,
//     });

//     try {
//       const response = await fetch(
//         `${host}/cancelBooking?bookingGroupId=${bookingGroupId}&reason=${encodeURIComponent(
//           cancellationReason
//         )}&userRole=${userRole}`,
//         {
//           method: "GET",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: localStorage.getItem("access_token"),
//           },
//         }
//       );

//       const data = await response.json();
//       console.log("Server Response:", data);

//       if (response.ok) {
//         alert(data.message);
//         return true; // Indicate success
//       } else {
//         alert("Cancellation failed: " + data.message);
//         return false;
//       }
//     } catch (error) {
//       console.error("Cancellation Error:", error);
//       alert("Cancellation failed. Please try again later.");
//       return false;
//     }
//   };

//   const handleModalClose = () => {
//     setShowModal(false);
//     setCancellationReason("");
//     setSelectedBooking(null);
//   };

//   const handleModalSubmit = () => {
//     if (!cancellationReason.trim()) {
//       alert("Please provide a reason for cancellation.");
//       return;
//     }

//     console.log("Cancellation reason:", cancellationReason); // Debugging
//     cancelBooking(
//       selectedBooking.booking_group_id,
//       selectedBooking.date,
//       cancellationReason
//     );
//     handleModalClose();
//   };

//   const handleApprove = async (bookingGroupId) => {
//     if (!isChecked) {
//       alert("Please confirm the details before approving.");
//       return;
//     }

//     console.log("Approved Booking:", selectedBooking);

//     try {
//       console.log("Sending booking_group_id:", bookingGroupId); // Debugging

//       const response = await fetch(`${host}/approveBooking`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: "Bearer " + localStorage.getItem("access_token"),
//         },
//         body: JSON.stringify({ booking_group_id: bookingGroupId }), // Send in the body
//       });

//       if (!response.ok) {
//         throw new Error("Failed to approve booking");
//       }

//       const updatedBooking = await response.json();

//       if (updatedBooking.success) {
//         alert("Venue successfully approved!"); // Show alert

//         // 🔄 Re-fetch latest booking data after approval
//         myBookingsList();

//         closeModal();
//       } else {
//         throw new Error("Approval failed");
//       }
//     } catch (error) {
//       console.error("Error approving booking:", error);
//     }
//   };

//   const handlePageChange = (newPage) => {
//     console.log("Page changed to:", newPage);
//     setCurrentPage(newPage);

//     const newPaginatedBookingList = bookingList.slice(
//       (newPage - 1) * itemsPerPage,
//       newPage * itemsPerPage
//     );

//     setPaginatedBookingList(newPaginatedBookingList);
//   };

//   const myBookingsListCallback = useCallback(() => {
//     // myBookingsList();
//   }, []);

//   useEffect(() => {
//     if (
//       !localStorage.getItem("access_token") ||
//       localStorage.getItem("access_token") === ""
//     ) {
//       navigate("/", "_self");
//     }

//     myBookingsListCallback();
//     // myBookingsList();
//   }, [currentPage, myBookingsListCallback]);

//   let userRole = localStorage.getItem("userRole");
//   let billingRequest = JSON.parse("{}");
//   let srNo = 0;
//   if (
//     localStorage.getItem("access_token") == undefined ||
//     localStorage.getItem("access_token") === ""
//   ) {
//     navigate("/", "_self");
//   }

//   // Add this inside your component function
//   useEffect(() => {
//     // console.log("Booking List:", bookingList);
//   }, [bookingList]);

//   const summaryView = (booking_group_id) => {
//     fetch(
//       host +
//         "/getBookingSummary?bookingGroupId=" +
//         booking_group_id +
//         "&access_token=" +
//         localStorage.getItem("access_token") +
//         "&time=" +
//         Math.round(new Date().getTime() / 1000),
//       {
//         method: "GET",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: localStorage.getItem("access_token"),
//         },
//       }
//     ).then((response) => {
//       response.json().then((rooms) => {
//         if (rooms.length === 0) {
//           console.error("No rooms found");
//           return;
//         }

//         let bookingDetailsDataFinal = [];
//         const orderId = rooms[0].order_id;
//         console.log("Order ID:", orderId);

//         billingRequest.locationId = rooms[0].location_id;
//         billingRequest.name = rooms[0].customer_name;
//         billingRequest.address = rooms[0].address;
//         billingRequest.contactno = rooms[0].contact_no;
//         billingRequest.email = rooms[0].email_id;
//         billingRequest.pan = rooms[0].pan_number;
//         billingRequest.aadhaar = rooms[0].aadhaar_number;
//         billingRequest.razorpay_status = rooms[0].razorpay_status;
//         billingRequest.orderId = rooms[0].booking_id;
//         billingRequest.bookingId = rooms[0].order_id;
//         billingRequest.is_approved = rooms[0].is_approved;

//         rooms.map((row) => {
//           let tmpBookingDetailsDataFinal = JSON.parse("{}");
//           tmpBookingDetailsDataFinal["room_name"] = row.room_name;
//           tmpBookingDetailsDataFinal["bookingDate"] = row.date;
//           tmpBookingDetailsDataFinal["amount"] = row.sub_total;
//           tmpBookingDetailsDataFinal["selectedPersons"] = row.extra_persons;
//           tmpBookingDetailsDataFinal["finalGrandTotalVal"] = row.sub_total;

//           bookingDetailsDataFinal.push(tmpBookingDetailsDataFinal);
//           console.log("Row Sub Total:", row.sub_total);
//         });

//         billingRequest.roomData = bookingDetailsDataFinal;
//         localStorage.setItem("billingRequest", JSON.stringify(billingRequest));
//         localStorage.setItem("bookingDetailsData", JSON.stringify("{}"));

//         navigate("/BookingSummary", {
//           state: {
//             orderId: rooms[0].order_id,
//             isApproved: rooms[0].is_approved,
//           },
//         });
//       });
//     });
//   };

//   console.log("tmpBookingDetailsDataFinal");
//   const handleViewDocument = (fileUrl) => {
//     if (!fileUrl) {
//       alert("Document URL is not available.");
//       return;
//     }

//     // Open the document in a new tab
//     window.open(fileUrl, "_blank", "noopener,noreferrer");
//   };

//   const myBookingsList = async () => {
//     try {
//       const response = await fetch(
//         host +
//           "/getMyBookingsList?access_token=" +
//           localStorage.getItem("access_token") +
//           "&time=" +
//           Math.round(new Date().getTime() / 1000),
//         {
//           method: "GET",
//           headers: {
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       if (response.status === 403) {
//         alert("Session expired. Please log in again.");
//         localStorage.removeItem("access_token"); // Clear token
//         navigate("/login", { replace: true }); // Redirect to login page
//         return;
//       }

//       if (!response.ok) {
//         throw new Error("Failed to fetch bookings");
//       }

//       const rooms = await response.json();
//       // console.log(rooms, "rooms");

//       if (!Array.isArray(rooms)) {
//         throw new Error("Invalid response format");
//       }

//       let bookingListArray = [];
//       let bookingListTmp = {};

//       if (rooms.length === 0) {
//         setNoData("No booking details available");
//       }

//       rooms.forEach((row) => {
//         // Group by booking_group_id and room_id
//         const roomKey = `${row.booking_group_id}-${row.room_id}`;

//         if (bookingListTmp[roomKey] !== undefined) {
//           let tmp = bookingListTmp[roomKey];
//           tmp.room_names = tmp.room_names + ", " + row.accommodation_type;

//           // Ensure the sub_total is added only once for the room
//           // Only add if the sub_total is not already set for this room in the group
//           if (!tmp.sub_total) {
//             tmp.sub_total = row.sub_total;
//           }
//           bookingListTmp[roomKey] = tmp;
//         } else {
//           row.room_names = row.room_names;
//           // Set sub_total once for each room in the booking group
//           row.sub_total = row.sub_total;
//           bookingListTmp[roomKey] = row;
//         }
//       });

//       // Convert the object to an array
//       Object.keys(bookingListTmp).forEach((key) => {
//         bookingListArray.push(bookingListTmp[key]);
//       });

//       const updatedBookingList = bookingListArray.map((booking) => {
//         const checkOutDate = moment(booking.date);
//         const currentDate = moment();
//         const isDateCompleted = currentDate.isAfter(checkOutDate, "day");

//         return {
//           ...booking,
//           cancelDisabled: booking.status === "Canceled" || isDateCompleted,
//         };
//       });

//       setBookingList(updatedBookingList);

//       const newTotalPageCount = Math.ceil(
//         updatedBookingList.length / itemsPerPage
//       );
//       setTotalPageCount(newTotalPageCount);

//       // Update the paginated list based on the current page
//       const newPaginatedBookingList = updatedBookingList.slice(
//         (currentPage - 1) * itemsPerPage,
//         currentPage * itemsPerPage
//       );

//       setPaginatedBookingList(newPaginatedBookingList);
//       console.log(newPaginatedBookingList.map((rm) => rm));
//       console.log(newPaginatedBookingList.map((rm) => rm.room_names));
//       console.log("Total Page Count:", newTotalPageCount);
//     } catch (error) {
//       console.error("Error fetching bookings:", error);
//       alert(
//         "There was an error fetching your bookings. Please try again later."
//       );
//     }
//   };

//   const handleApplyDiscount = async () => {
//     if (!discountPercentage || !discountReason) {
//       alert("Please enter both discount percentage and reason.");
//       return;
//     }

//     try {
//       const response = await fetch(`${host}/applyDiscount`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: "Bearer " + localStorage.getItem("access_token"),
//         },
//         body: JSON.stringify({
//           booking_group_id: selectedBooking.booking_group_id,
//           discount_percentage: discountPercentage,
//           reason: discountReason,
//         }),
//       });

//       const result = await response.json();

//       if (result.success) {
//         alert("Discount applied successfully!");
//         setShowDiscountModal(false);
//         // myBookingsList();
//       } else {
//         alert("Failed to apply discount.");
//       }
//     } catch (error) {
//       console.error("Error applying discount:", error);
//     }
//   };

//   const handleUpload = async () => {
//     if (!electricityBill) {
//       alert("Electricity Bill is required!");
//       return;
//     }

//     const formData = new FormData();
//     if (damagedFile) formData.append("damagedFile", damagedFile);
//     formData.append("electricityBill", electricityBill);

//     try {
//       const response = await fetch(`${host}/upload`, {
//         method: "POST",
//         body: formData,
//       });

//       const result = await response.json();
//       alert(result.message);
//     } catch (error) {
//       console.error("Error uploading files:", error);
//     }
//   };

//   const handleRiChange = async (selectedRi, bookingGroupId) => {
//     if (!selectedRi) return;

//     try {
//       const response = await fetch(`${host}/updateRoomBookingRI`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: "Bearer " + localStorage.getItem("access_token"),
//         },
//         body: JSON.stringify({
//           booking_group_id: bookingGroupId,
//           ri_value: selectedRi,
//         }),
//       });

//       const result = await response.json();

//       if (!response.ok) {
//         throw new Error(result.message || "Failed to update RI value.");
//       }

//       alert("RI value updated successfully!"); // ✅ Alert before updating UI
//       // myBookingsList();
//       // 🔄 Immediately update UI to replace dropdown with text
//       setBookingList((prevBookings) =>
//         prevBookings.map((booking) =>
//           booking.booking_group_id === bookingGroupId
//             ? { ...booking, ri_value: selectedRi }
//             : booking
//         )
//       );
//     } catch (error) {
//       console.error("Error updating RI value:", error);
//       alert("Error updating RI value.");
//     }
//   };

//     const [selectedRole, setSelectedRole] = useState("");
//   const [appStatus, setAppStatus] = useState("");
  
//   // 🔹 Role → App Status Mapping
//   const roleToStatusMap = {
//     RI: "Waiting for Remarks",
//     AO: "waiting for AO approval",
//     Secretary: "waiting for comm-sec approval",
//     CAO: "Waiting for CAO verification approval",
//     "CAO-AO": "Waiting for CAO-AO Approval",
//   };
  
//   // 🔹 Handle Role Change
//   const handleRoleChange = (e) => {
//     const role = e.target.value;
//     setSelectedRole(role);
//     setAppStatus(roleToStatusMap[role] || "");
//   };
  
//   // 🔹 Updated Reassign API Call
//   // const handleReassign = async () => {
//   //   if (!selectedRole) {
//   //     alert("Please select a role to reassign.");
//   //     return;
//   //   }
  
//   //   try {
//   //     const response = await fetch(`${host}/reassign`, {
//   //       method: "POST",
//   //       headers: { "Content-Type": "application/json" },
//   //       body: JSON.stringify({
//   //         booking_group_id: selectedBooking.booking_group_id,
//   //         remarks: remarks,
//   //         added_by: userRole, // logged in role
//   //         reassign_to: selectedRole,
//   //         app_status: appStatus, // 🔹 now we pass the correct app_status automatically
//   //       }),
//   //     });
  
//   //     const data = await response.json();
//   //     if (response.ok) {
//   //       alert(data.message);
//   //       setShowDiscountModal(false);
//   //     } else {
//   //       alert(data.message || "Failed to reassign");
//   //     }
//   //   } catch (error) {
//   //     console.error("Error reassigning:", error);
//   //     alert("Something went wrong");
//   //   }
//   // };

//   const handleReassign = async () => {
//   if (!selectedRole) {
//     alert("Please select a role to reassign.");
//     return;
//   }

//   const userRole = localStorage.getItem("userRole");

//   // ✅ Retrieve attachments from localStorage (if uploaded earlier)
//   const damagedFileUrl = localStorage.getItem("damagedFile") || null;
//   const electricityBillUrl = localStorage.getItem("electricityBill") || null;
//   const discountFileUrl = localStorage.getItem("discountFile") || null;

//   try {
//     const response = await fetch(`${host}/reassign`, {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({
//         booking_group_id: selectedBooking.booking_group_id,
//         remarks: remarks,
//         added_by: userRole,         // logged in role
//         reassign_to: selectedRole,  // new role
//         app_status: appStatus,      // correct app_status
//         damagedAttachment: damagedFileUrl,
//         electricityAttachment: electricityBillUrl,
//         discountAttachment: discountFileUrl
//       }),
//     });

//     const data = await response.json();
//     if (response.ok) {
//       alert(data.message);

//       // ✅ Clear attachments after successful reassign
//       localStorage.removeItem("damagedFile");
//       localStorage.removeItem("electricityBill");
//       localStorage.removeItem("discountFile");

//       setShowDiscountModal(false);
//       window.location.reload();
//     } else {
//       alert(data.message || "Failed to reassign");
//     }
//   } catch (error) {
//     console.error("Error reassigning:", error);
//     alert("Something went wrong");
//   }
// };


//   const [totalPageCount, setTotalPageCount] = useState(1);

//   const bookingSummary = () => {};

//   const refreahData = () => {
//     // myBookingsList();
//   };

//   const [filters, setFilters] = useState({
//     checkInDate: "",
//     bookingDate: "",
//     customerName: "",
//     venueName: "",
//     status: "",
//   });

//   // const handleFilterChange = (e) => {
//   //   setFilters({ ...filters, [e.target.name]: e.target.value });
//   // };

//   const handleFilterChange = (e) => {
//     setFilters({ ...filters, [e.target.name]: e.target.value });
//     setCurrentPage(1); // optional: reset to first page on filter change
//   };
//   // const filteredBookings = bookingList.filter((rm) => {
//   //   return (
//   //     (!filters.checkInDate ||
//   //       moment(rm.date).format("DD-MMM-YYYY") ===
//   //         moment(filters.checkInDate).format("DD-MMM-YYYY")) && // Filter by check-in date
//   //     (!filters.bookingDate ||
//   //       moment(rm.booking_date).format("DD-MMM-YYYY") ===
//   //         moment(filters.bookingDate).format("DD-MMM-YYYY")) && // Filter by booking date
//   //     (!filters.customerName ||
//   //       rm.customer_name
//   //         .toLowerCase()
//   //         .includes(filters.customerName.toLowerCase())) &&
//   //     (!filters.venueName ||
//   //       rm.room_names
//   //         .toLowerCase()
//   //         .includes(filters.venueName.toLowerCase())) &&
//   //     (!filters.status || rm.status.toString() === filters.status)
//   //   );
//   // });
 
//    const filteredBookings = bookingList.filter((rm) => {
//   return (
//     (!filters.checkInDate ||
//       rm.dates?.split(",").some(
//         (d) =>
//           moment(d).format("DD-MMM-YYYY") ===
//           moment(filters.checkInDate).format("DD-MMM-YYYY")
//       )) &&
//     (!filters.bookingDate ||
//       moment(rm.booking_date).format("DD-MMM-YYYY") ===
//         moment(filters.bookingDate).format("DD-MMM-YYYY")) &&
//     (!filters.customerName ||
//       rm.customer_name
//         ?.toLowerCase()
//         .includes(filters.customerName.toLowerCase())) &&
//     (!filters.venueName ||
//       rm.room_names
//         ?.toLowerCase()
//         .includes(filters.venueName.toLowerCase())) &&
//     (!filters.app_status ||
//       (rm.app_status || "")
//         .toLowerCase()
//         .includes(filters.app_status.toLowerCase()))
//   );
// });
//   const startIndex = (currentPage - 1) * itemsPerPage;
//   const endIndex = startIndex + itemsPerPage;

//   const paginatedFilteredBookings = filteredBookings.slice(
//     startIndex,
//     endIndex
//   );

//   useEffect(() => {
//     myBookingsList();
//     myBookingsListCallback();
//   }, [currentPage]);
//   const onChangeLocation = () => {
//     // myBookingsList();
//     // populateAvailableRoomsInCalender(moment(nextDates[0]).format("DD-MMM-YYYY"));
//     //checkAvailability();
//   };
//   return (
//     <div>
//       <Header />
//       {/* <Navbar /> */}
//       <div className="container-fluid">
//         <div className="row">
//           {/* <div className="col-lg-2"></div> */}
//           <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12  content_back">
//             <div className="row">
//               <b>Booking Details</b>
//             </div>

//             <div className="filter-container">
//               <div className="filter-item">
//                 <label>Event Date:</label>
//                 <input
//                   type="date"
//                   name="checkInDate"
//                   value={filters.checkInDate}
//                   onChange={handleFilterChange}
//                 />
//               </div>
//               <div className="filter-item">
//                 <label>Booking Date:</label>
//                 <input
//                   type="date"
//                   name="bookingDate"
//                   value={filters.bookingDate}
//                   onChange={handleFilterChange}
//                 />
//               </div>

//               <div className="filter-item">
//                 <label>Customer Name:</label>
//                 <input
//                   type="text"
//                   name="customerName"
//                   value={filters.customerName}
//                   onChange={handleFilterChange}
//                   placeholder="Enter Customer Name"
//                 />
//               </div>

//               <div className="filter-item">
//                 <label>Venue Name:</label>
//                 <input
//                   type="text"
//                   name="venueName"
//                   value={filters.venueName}
//                   onChange={handleFilterChange}
//                   placeholder="Enter Venue Name"
//                 />
//               </div>
//             </div>
//             <div className="row" style={{ overflowX: "auto" }}>
//               <table className="table table-striped responsive-table">
//                 <thead>
//                   <tr
//                     className="data-row-head"
//                     style={{ whiteSpace: "nowrap" }}
//                   >
//                     <th>S No</th>
//                     <th>Venue Details</th>
//                     <th>Venue Type</th>
//                     <th>Event Date</th>
//                     <th>Contact Name</th>
//                     <th>Contact No</th>
//                     <th>Amount</th>
//                     <th>Remarks</th>
//                     <th>Event Status</th>
//                     <th>Refund Status</th>
//                     <th>Electricity Attachment</th>
//                     <th>Damaged Attachment</th>
//                     <th>Discount Attachment</th>

//                     <th>Booking Date</th>
//                     <th>Cancel</th>
//                     <th>Reassign Status</th>
//                   </tr>
//                 </thead>
//                 <tbody style={{ whiteSpace: "nowrap" }}>
//                   {paginatedFilteredBookings.map((rm, index) => (
//                     <tr key={rm.booking_group_id} className="data-row-data">
//                       {/* <td style={{ textAlign: "center" }}>{index + 1}</td> */}
//                       <td style={{ textAlign: "center" }}>
//                         {(currentPage - 1) * itemsPerPage + index + 1}
//                       </td>
//                       <td style={{ textAlign: "center" }}>
//                         {rm.accommodation_type}
//                       </td>
//                       <td style={{ textAlign: "center" }}>{rm.room_names}</td>
//                       {/* <td style={{ textAlign: "center" }}>
//                         {moment(rm.date).format("DD-MMM-YYYY")}
//                       </td> */}

//                                            <td style={{ textAlign: "center" }}>
//   {rm.dates
//     ? (() => {
//         const arr = rm.dates.split(",").map(d => moment(d).format("DD-MMM-YYYY"));
//         return arr.length === 1 ? arr[0] : `${arr[0]} to ${arr[arr.length - 1]}`;
//       })()
//     : "-"}
// </td>
//                       <td style={{ textAlign: "center" }}>
//                         {rm.customer_name}
//                       </td>
//                       <td style={{ textAlign: "center" }}>{rm.contact_no}</td>
//                       <td style={{ textAlign: "center" }}>{rm.sub_total}</td>

//                       {/* Remarks Column (Editable for UserRole 5) */}

//                       <td style={{ textAlign: "center" }}>
//                         {rm.remarks}
//                         {rm.app_status === "Waiting for Remarks" && (
//                           <i
//                             className="fa fa-edit"
//                             onClick={() => openRemarksPopup(rm)}
//                             style={{
//                               cursor: "pointer",
//                               marginLeft: "10px",
//                               color: "blue",
//                             }}
//                           ></i>
//                         )}
//                       </td>

//                       {/* Event Status Column (Dropdown for UserRole 5) */}

//                       <td>{rm.event_status}</td>
//                       <td>{rm.app_status}</td>
//                       {/* <td style={{ textAlign: "center" }}>
//                         {rm.reviews &&
//                         rm.reviews.length > 0 &&
//                         rm.reviews[0].electricityAttachment ? (
//                           <a
//                             href={rm.reviews[0].electricityAttachment}
//                             target="_blank"
//                             rel="noopener noreferrer"
//                           >
//                             View
//                           </a>
//                         ) : (
//                           ""
//                         )}
//                       </td>

//                       <td style={{ textAlign: "center" }}>
//                         {rm.reviews &&
//                         rm.reviews.length > 0 &&
//                         rm.reviews[0].damagedAttachment ? (
//                           <a
//                             href={rm.reviews[0].damagedAttachment}
//                             target="_blank"
//                             rel="noopener noreferrer"
//                           >
//                             View
//                           </a>
//                         ) : (
//                           ""
//                         )}
//                       </td> */}

//                           <td style={{ textAlign: "center" }}>
//                         {rm.reviews &&
//                         rm.reviews.length > 0 &&
//                         rm.reviews[0].electricityAttachment ? (
//                           <a
//                             href={rm.reviews[0].electricityAttachment}
//                             target="_blank"
//                             rel="noopener noreferrer"
//                           >
//                             View
//                           </a>
//                         ) : (
//                           ""
//                         )}
//                       </td>

//                       <td style={{ textAlign: "center" }}>
//                         {rm.reviews &&
//                         rm.reviews.length > 0 &&
//                         rm.reviews[0].damagedAttachment ? (
//                           <a
//                             href={rm.reviews[0].damagedAttachment}
//                             target="_blank"
//                             rel="noopener noreferrer"
//                           >
//                             View
//                           </a>
//                         ) : (
//                           ""
//                         )}
//                       </td>

//                         <td style={{ textAlign: "center" }}>
//     {rm.discount_attachment ? (
//       <a
//         href={rm.discount_attachment}
//         target="_blank"
//         rel="noopener noreferrer"
//       >
//         View
//       </a>
//     ) : (
//       ""
//     )}
//   </td>

//                       <td style={{ textAlign: "center" }}>
//                         {moment(rm.booking_date).format("DD-MMM-YYYY")}{" "}
//                       </td>

//                        <td>
//                         <button
//                           // onClick={() => handleCancelClick(rm)}
//                           disabled={rm.cancelDisabled || rm.status === 2}
//                           className={
//                             "view-document-button " +
//                             (rm.cancelDisabled || rm.status === 2
//                               ? "disabledButton"
//                               : "")
//                           }
//                           style={{
//                             padding: "6px",
//                             background: "#d20909e8",
//                             border: "none",
//                             borderRadius: "4px",
//                             color: "#fff",
//                           }}
//                         >
//                           {rm.status === 2 ? "cancelled" : "Cancel"}
//                         </button>
//                       </td>
//                       <td style={{ textAlign: "center" }}>
//                         {rm.reassign_status || ""} </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>

//               {/* Remarks original Popup and also rejection process */}

//               {showRemarksPopup && selectedBooking && (
//                 <div className="modal-overlay">
//                   <div className="modal-container">
//                     {/* Modal Header */}
//                     <div className="modal-header">
//                       <h2 className="modal-title"> Remarks</h2>
//                       <button
//                         type="button"
//                         className="close-btn"
//                         onClick={() => setShowRemarksPopup(false)}
//                       >
//                         ✖
//                       </button>
//                     </div>

//                     {/* Modal Body */}
//                     <div className="modal-content">
//                       <div className="row">
//                         <div className="col-4">
//                           <p>
//                             <strong>Venue :</strong>
//                           </p>
//                           <span className="roomnames">
//                             {selectedBooking.accommodation_type || "N/A"}
//                           </span>
//                         </div>
//                         <div className="col-4">
//                           <p>
//                             <strong>Venue Type :</strong>
//                           </p>
//                           <span className="roomnames">
//                             {selectedBooking.room_names || "N/A"}
//                           </span>
//                         </div>
//                         <div className="col-4">
//                           <p>
//                             <strong>Event Date :</strong>
//                           </p>
//                           <span className="roomnames">
//                             {/* {moment(selectedBooking.date).format("DD-MMM-YYYY")} */}
//                              {selectedBooking.dates
//     ? (() => {
//         const arr = selectedBooking.dates.split(",").map(d => moment(d).format("DD-MMM-YYYY"));
//         return arr.length === 1 ? arr[0] : `${arr[0]} to ${arr[arr.length - 1]}`;
//       })()
//     : "-"}
//                           </span>
//                         </div>
//                       </div>

//                       {/* Second Line: Customer Name, Phone, Email */}
//                       <div className="row">
//                         <div className="col-4">
//                           <p>
//                             <strong>Name:</strong>
//                           </p>
//                           <span className="roomnames">
//                             {selectedBooking.customer_name || "N/A"}
//                           </span>
//                         </div>
//                         <div className="col-4">
//                           <p>
//                             <strong>Phone:</strong>
//                           </p>
//                           <span className="roomnames">
//                             {selectedBooking.contact_no || "N/A"}
//                           </span>
//                         </div>
//                         <div className="col-4">
//                           <p>
//                             <strong>Email:</strong>
//                           </p>
//                           <span className="roomnames">
//                             {selectedBooking.email || "N/A"}
//                           </span>
//                         </div>
//                       </div>

                        
//                     <table className="table table-responsive">
//                       <thead>
//                         <tr>
//                           <th>Rent</th>
//                           <th>GST</th>
//                           <th>Security Deposit</th>
//                           <th>Cleaning Charges</th>
//                           <th>Total Amount</th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         <tr>
//                           <td>₹{selectedBooking.total_rent}</td>
//                           <td>₹{selectedBooking.total_gst}</td>
//                           <td>₹{selectedBooking.total_security_deposit}</td>
//                           <td>₹{selectedBooking.total_cleaning_charges}</td>
//                           <td>₹{selectedBooking.sub_total}</td>
//                         </tr>
//                       </tbody>
//                     </table>

                      

//                       <div className="row">
//                         <div className="col-12">
//                           <p>
//                             <strong>Remarks:</strong>
//                           </p>
//                           <textarea
//                             value={remarks}
//                             onChange={(e) => setRemarks(e.target.value)}
//                             placeholder="Enter remarks..."
//                             rows={4}
//                             className="remarks-input"
//                             style={{ width: "inherit" }}
//                           />
//                         </div>
//                       </div>

//                       {selectedBooking.file_url && (
//                         <div className="row">
//                           <div className="col-12">
//                             <span>
//                               <strong>Attachment of Proof &nbsp;:</strong>
//                             </span>
//                             <a href={selectedBooking.file_url} target="_blank">
//                               &nbsp; view
//                             </a>
//                           </div>
//                         </div>
//                       )}

//                       <div className="row">
//                         <div className="col-4">
//                           <p>
//                             <strong>Attach Damaged Files:</strong>
//                           </p>
//                           <input
//                             type="file"
//                             className="file-input"
//                             onChange={(e) => handleFileChange(e, "damagedFile")}
//                           />
//                         </div>
//                         <div className="col-4">
//                           <p>
//                             <strong>Attach Electricity Bill:</strong>
//                           </p>
//                           <input
//                             type="file"
//                             onChange={(e) =>
//                               handleFileChange(e, "electricityBill")
//                             }
//                             className="file-input"
//                           />
//                         </div>
//                         <div className="col-4">
//                           <p>
//                             <strong>Attach Discount Proof:</strong>
//                           </p>
//                           {/* <input
//                             type="file"
//                             className="file-input"
//                             onChange={(e) =>
//                               handleFileChange(e, "discountFile")
//                             }
//                           /> */}
//                           {selectedBooking.discount_attachment ? (
//                             <a
//                               href={selectedBooking.discount_attachment}
//                               download
//                               className="view-document-button"
//                               style={{ display: "block", marginTop: "5px" }}
//                             >
//                               View Attachment
//                             </a>
//                           ) : (
//                             <input
//                               type="file"
//                               accept=".jpg,.jpeg,.png,.pdf"
//                               className="file-input"
//                               onChange={(e) =>
//                                 handleFileChange(e, "discountFile")
//                               }
//                               style={{ display: "block", marginTop: "5px" }}
//                             />
//                           )}
//                         </div>
//                       </div>

//    <div className="row">
//   {/* Discount Applicable Dropdown */}
//   <div className="col-6">
//     <p>
//       <strong>Discount Applicable:</strong>
//     </p>
//     <select
//       value={isDiscountApplicable}
//       onChange={(e) => setIsDiscountApplicable(e.target.value)}
//       className="popup-input"
//       style={{ width: "100%" }}
//     >
//       <option value="">Select</option>
//       <option value="Yes">Yes</option>
//       <option value="No">No</option>
//     </select>
//   </div>

//   {/* Remarks → show only when Yes */}
//   {isDiscountApplicable === "Yes" && (
//     <div className="col-6">
//       <p>
//         <strong>Remarks:</strong>
//       </p>
//       <textarea
//         value={discountRemarks}
//         onChange={(e) => setDiscountRemarks(e.target.value)}
//         placeholder="Enter discount % , amount, and remarks..."
//         rows={4}
//         className="remarks-input"
//         style={{ width: "100%" }}
//       />
//     </div>
//   )}
// </div>



//                       <div className="form-check">
//                         <input
//                           type="checkbox"
//                           className="form-check-input"
//                           id="confirmCheck"
//                           checked={isChecked}
//                           onChange={(e) => setIsChecked(e.target.checked)}
//                         />
//                         <label
//                           className="form-check-label"
//                           htmlFor="confirmCheck"
//                         >
//                           I have checked and confirmed that the information is
//                           correct.
//                         </label>
//                       </div>
//                     </div>

//                     {/* Modal Actions */}
//                     <div className="modal-actions">
//                       <button
//                         onClick={handleRemarksSubmit}
//                         className="approve-btn"
//                       >
//                         Submit To AO
//                       </button>
//                       {/* <button
//                         onClick={() => setShowRemarksPopup(false)}
//                         className="cancel-btn"
//                       >
//                         Cancel
//                       </button> */}

//                         <select
//   value={selectedRole}
//   onChange={handleRoleChange}
//   className="popup-input" style={{width:"30%"}}
// >
//   <option value="">Select Role to Reassign</option>
//   <option value="RI">RI</option>
//   <option value="AO">AO</option>
//   <option value="Secretary">Secretary</option>
//   <option value="CAO">CAO</option>
//   <option value="CAO-AO">CAO-AO</option>
// </select>

// {/* 🔹 Show app status preview */}
// {appStatus && (
//   <p style={{ marginTop: "6px", fontStyle: "italic", color: "#666" }}>
//     New Status: {appStatus}
//   </p>
// )}

// <button onClick={handleReassign} className="cancelButton">
//   Reassign
// </button>
//                     </div>
//                   </div>
//                 </div>
//               )}

//               {/* Event Status Popup (Waiting for Remarks) */}
//               {showStatusPopup && selectedBooking && (
//                 <div className="modal-overlay">
//                   <div className="modal-container">
//                     {/* Modal Header */}
//                     <div className="modal-header">
//                       <h2 className="modal-title"> Remarks</h2>
//                       <button
//                         type="button"
//                         className="close-btn"
//                         onClick={() => setShowStatusPopup(false)}
//                       >
//                         ✖
//                       </button>
//                     </div>

//                     {/* Modal Body */}
//                     <div className="modal-content">
//                       <div className="row">
//                         <div className="col-4">
//                           <p>
//                             <strong>Venue :</strong>
//                           </p>
//                           <span className="roomnames">
//                             {selectedBooking.accommodation_type || "N/A"}
//                           </span>
//                         </div>
//                         <div className="col-4">
//                           <p>
//                             <strong>Venue Type :</strong>
//                           </p>
//                           <span className="roomnames">
//                             {selectedBooking.room_names || "N/A"}
//                           </span>
//                         </div>
//                         <div className="col-4">
//                           <p>
//                             <strong>Event Date :</strong>
//                           </p>
//                           <span className="roomnames">
//                             {moment(selectedBooking.date).format("DD-MMM-YYYY")}
//                           </span>
//                         </div>
//                       </div>

//                       {/* Second Line: Customer Name, Phone, Email */}
//                       <div className="row">
//                         <div className="col-4">
//                           <p>
//                             <strong>Name:</strong>
//                           </p>
//                           <span className="roomnames">
//                             {selectedBooking.customer_name || "N/A"}
//                           </span>
//                         </div>
//                         <div className="col-4">
//                           <p>
//                             <strong>Phone:</strong>
//                           </p>
//                           <span className="roomnames">
//                             {selectedBooking.contact_no || "N/A"}
//                           </span>
//                         </div>
//                         <div className="col-4">
//                           <p>
//                             <strong>Email:</strong>
//                           </p>
//                           <span className="roomnames">
//                             {selectedBooking.email || "N/A"}
//                           </span>
//                         </div>
//                       </div>

//                       {/* Event Name */}

//                       {/* Purpose & Proof Attachment */}
//                       <div className="row">
//                         <div className="col-12">
//                           <span>
//                             <strong>Concession Type &nbsp;:</strong>
//                           </span>
//                           <span>&nbsp; {selectedBooking.purpose || "N/A"}</span>
//                         </div>
//                       </div>

//                       {/* Assigned to RI */}
//                       <div className="row">
//                         <div className="col-12">
//                           <span>
//                             <strong>Assigned to &nbsp;:</strong>
//                           </span>
//                           <span>
//                             &nbsp; {selectedBooking.ri_value || "Not Assigned"}
//                           </span>
//                         </div>
//                       </div>

//                       {/* Remarks Input Field */}
//                       <div className="row">
//                         <div className="col-12">
//                           <p>
//                             <strong>Remarks:</strong>
//                           </p>
//                           <textarea
//                             value={remarks}
//                             onChange={(e) => setRemarks(e.target.value)}
//                             placeholder="Enter remarks..."
//                             rows={4}
//                             className="remarks-input"
//                             style={{ width: "inherit" }}
//                           />
//                         </div>
//                       </div>

//                       {/* File Attachment */}
//                       <div className="row">
//                         <div className="col-12">
//                           <p>
//                             <strong>Attach Damaged Files:</strong>
//                           </p>
//                           <input
//                             type="file"
//                             multiple
//                             onChange={(e) => setAttachment(e.target.files[0])}
//                             className="file-input"
//                           />
//                         </div>
//                       </div>

//                       <div className="row">
//                         <div className="col-12">
//                           <p>
//                             <strong>Attach Electricity Bill:</strong>
//                           </p>
//                           <input
//                             type="file"
//                             onChange={(e) => setAttachment(e.target.files[0])}
//                             className="file-input"
//                           />
//                         </div>
//                       </div>
//                     </div>

//                     {/* Modal Actions */}
//                     <div className="modal-actions">
//                       <button
//                         onClick={handleStatusSubmit}
//                         className="approve-btn"
//                       >
//                         Submit
//                       </button>
//                       <button
//                         onClick={() => setShowStatusPopup(false)}
//                         className="cancel-btn"
//                       >
//                         Cancel
//                       </button>
//                     </div>
//                   </div>
//                 </div>
//               )}
//             </div>

//             {showModal && (
//               <div className="modal-overlay">
//                 <div className="modal-content">
//                   <h3>Reason for Cancellation</h3>
//                   <textarea
//                     value={cancellationReason}
//                     onChange={(e) => setCancellationReason(e.target.value)}
//                     placeholder="Enter reason for cancellation"
//                     rows="4"
//                     style={{ width: "100%" }}
//                   />
//                   <div style={{ marginTop: "10px" }}>
//                     <button
//                       onClick={handleModalSubmit}
//                       style={{ marginRight: "10px" }}
//                     >
//                       Submit
//                     </button>
//                     <button onClick={handleModalClose}>Cancel</button>
//                   </div>
//                 </div>
//               </div>
//             )}

//             {showPopup && (
//               <div className="popup-overlay">
//                 <div className="popup-content">
//                   <h3>Allot To RI</h3>
//                   <div class="form-check-inline">
//                     <input
//                       className="form-check-input"
//                       type="radio"
//                       value="RI1"
//                       checked={selectedRI === "RI1"}
//                       onChange={() => setSelectedRI("RI1")}
//                     />
//                     <label className="form-check-label">RI1</label>
//                   </div>
//                   <div class="form-check-inline">
//                     <input
//                       className="form-check-input"
//                       type="radio"
//                       value="RI2"
//                       checked={selectedRI === "RI2"}
//                       onChange={() => setSelectedRI("RI2")}
//                     />
//                     <label className="form-check-label">RI2</label>
//                   </div>
//                   <div class="form-check-inline">
//                     <input
//                       className="form-check-input"
//                       type="radio"
//                       value="RI3"
//                       checked={selectedRI === "RI3"}
//                       onChange={() => setSelectedRI("RI3")}
//                     />
//                     <label className="form-check-label">RI3</label>
//                   </div>
//                   <div className="popup-buttons">
//                     {/* <button onClick={handleApproval} className="approveButton">
//                       Approve
//                     </button> */}

//                     <button
//                       type="button"
//                       onClick={handleApproval}
//                       className="approveButton"
//                     >
//                       Approve
//                     </button>

//                     <button onClick={closePopup} className="cancelButton">
//                       Cancel
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             )}

//             {showDiscountModal && selectedBooking && (
//               <div className="popup-overlay">
//                 <div className="popup-content">
//                   <h3>Apply Discount</h3>
//                   <p>
//                     <strong>Name:</strong> {selectedBooking.customer_name}
//                   </p>
//                   <p>
//                     <strong>Mobile No:</strong> {selectedBooking.contact_no}
//                   </p>
//                   <p>
//                     <strong>Amount:</strong> Rs.{selectedBooking.sub_total}
//                   </p>

//                   <label>Discount Percentage (%):</label>
//                   <input
//                     type="number"
//                     value={discountPercentage}
//                     onChange={(e) => setDiscountPercentage(e.target.value)}
//                     min="0"
//                     max="100"
//                   />

//                   <label>Reason:</label>
//                   <textarea
//                     value={discountReason}
//                     onChange={(e) => setDiscountReason(e.target.value)}
//                   />

//                   <div className="popup-buttons">
//                     <button
//                       onClick={handleApplyDiscount}
//                       className="approveButton"
//                     >
//                       Apply Discount
//                     </button>
//                     <button
//                       onClick={() => setShowDiscountModal(false)}
//                       className="cancelButton"
//                     >
//                       Cancel
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             )}

//             {isModalOpen && selectedBooking && (
//               <div className="modal-overlay">
//                 <div className="modal-container">
//                   {/* Modal Header */}
//                   <div className="modal-header">
//                     <h2 className="modal-title">Approve Booking</h2>
//                     <button
//                       type="button"
//                       className="close-btn"
//                       onClick={closeModal}
//                     >
//                       ✖
//                     </button>
//                   </div>

//                   {/* Modal Body */}
//                   <div className="modal-content">
//                     {/* First Line: Venue Name & Event Date */}
//                     <div className="row">
//                       <div className="col-4">
//                         <p>
//                           <strong>Venue :</strong>
//                         </p>
//                         <span className="roomnames">
//                           {selectedBooking.accommodation_type || "N/A"}
//                         </span>
//                       </div>
//                       <div className="col-4">
//                         <p>
//                           <strong>Venue Type :</strong>
//                         </p>
//                         <span className="roomnames">
//                           {selectedBooking.room_names || "N/A"}
//                         </span>
//                       </div>
//                       <div className="col-4">
//                         <p>
//                           <strong>Event Date :</strong>
//                         </p>
//                         <span className="roomnames">
//                           {moment(selectedBooking.date).format("DD-MMM-YYYY")}
//                         </span>
//                       </div>
//                     </div>

//                     {/* Second Line: Customer Name, Phone, Email */}
//                     <div className="row">
//                       <div className="col-4">
//                         <p>
//                           <strong>Name:</strong>
//                         </p>
//                         <span className="roomnames">
//                           {selectedBooking.customer_name || "N/A"}
//                         </span>
//                       </div>
//                       <div className="col-4">
//                         <p>
//                           <strong>Phone:</strong>
//                         </p>
//                         <span className="roomnames">
//                           {selectedBooking.contact_no || "N/A"}
//                         </span>
//                       </div>
//                       <div className="col-4">
//                         <p>
//                           <strong>Email:</strong>
//                         </p>
//                         <span className="roomnames">
//                           {selectedBooking.email || "N/A"}
//                         </span>
//                       </div>
//                     </div>

//                     {/* Third Line: Tabular Format for Rent, GST, etc. */}
//                     <table className="table">
//                       <thead>
//                         <tr>
//                           <th>Rent</th>
//                           <th>GST</th>
//                           <th>Security Deposit</th>
//                           <th>Cleaning Charges</th>
//                           <th>Total Amount</th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         <tr>
//                           <td>₹{selectedBooking.total_rent}</td>
//                           <td>₹{selectedBooking.total_gst}</td>
//                           <td>₹{selectedBooking.total_security_deposit}</td>
//                           <td>₹{selectedBooking.total_cleaning_charges}</td>
//                           <td>₹{selectedBooking.sub_total}</td>
//                         </tr>
//                       </tbody>
//                     </table>

//                     {/* Purpose & Proof Attachment */}
//                     <div className="row">
//                       <div className="col-12">
//                         <span>
//                           <strong>Concession Type &nbsp;:</strong>
//                         </span>
//                         <span>&nbsp; {selectedBooking.purpose || "N/A"}</span>
//                       </div>
//                     </div>

//                     {selectedBooking.file_url && (
//                       <div className="row">
//                         <div className="col-12">
//                           <span>
//                             <strong>Attachment of Proof &nbsp;:</strong>
//                           </span>
//                           <a href={selectedBooking.file_url} target="_blank">
//                             &nbsp; view
//                           </a>
//                         </div>
//                       </div>
//                     )}

//                     {/* Assigned to RI */}
//                     <div className="row">
//                       <div className="col-12">
//                         <span>
//                           <strong>Assigned to &nbsp;:</strong>
//                         </span>
//                         <span>
//                           &nbsp; {selectedBooking.ri_value || "Not Assigned"}
//                         </span>
//                       </div>
//                     </div>

//                     {/* Checkbox Confirmation */}
//                     <div className="form-check">
//                       <input
//                         type="checkbox"
//                         className="form-check-input"
//                         id="confirmCheck"
//                         checked={isChecked}
//                         onChange={(e) => setIsChecked(e.target.checked)}
//                       />
//                       <label
//                         className="form-check-label"
//                         htmlFor="confirmCheck"
//                       >
//                         I have checked and confirmed that the information is
//                         correct .
//                       </label>
//                     </div>
//                   </div>

//                   {/* Modal Actions */}
//                   <div className="modal-actions">
//                     <button
//                       onClick={() =>
//                         handleApprove(selectedBooking.booking_group_id)
//                       }
//                       disabled={!isChecked}
//                       className="approve-btn"
//                     >
//                       Approve
//                     </button>
//                     <button onClick={closeModal} className="cancel-btn">
//                       Cancel
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             )}

//             <div className="col-lg-2"></div>
//             <div className="pagination">
//               <button
//                 className="btn-next-my"
//                 onClick={() => handlePageChange(currentPage - 1)}
//                 disabled={currentPage === 1}
//               >
//                 Prev
//               </button>
//               <span
//                 style={{ paddingTop: "15px" }}
//               >{`Page ${currentPage} of ${totalPageCount}`}</span>
//               <button
//                 className="btn-next-my"
//                 onClick={() => handlePageChange(currentPage + 1)}
//                 disabled={currentPage === totalPageCount}
//               >
//                 Next
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default RIbookings;






import React, { useEffect, useState, useCallback } from "react";

import Navbar from "../components/Navbar";
import Header from "./Header";
// import "./Header.css";
import "./MyBookings.css";

import moment from "moment";

import { Link, useNavigate } from "react-router-dom";
import host from "../config";
const RIbookings = () => {
  const navigate = useNavigate();

  // let host = "https://api.vmrdarental.com";
  // let host = "https://api.vmrdarental.com";
  const [paginatedBookingList, setPaginatedBookingList] = useState([]);

  const [noData, setNoData] = useState();
  const [bookingData, setBookingData] = useState([]);
  const [bookingList, setBookingList] = useState([]);
  const [statusCheck, setStatusCheck] = useState(false);
  const [isShow, invokeModal] = React.useState(false);
  const [editableRoom, setEditableRoom] = React.useState({});

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 20;
  const [showPopup, setShowPopup] = useState(false);
  // const [cancellationReason, setCancellationReason] = useState("");
  // const [selectedBooking, setSelectedBooking] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [cancellationReason, setCancellationReason] = useState("");
  const [remarksMode, setRemarksMode] = useState("normal");
const [remarksData, setRemarksData] = useState([]); // For date-wise attachments

  const [selectedBooking, setSelectedBooking] = useState(null);
  const [refundReason, setRefundReason] = useState("");
  const [selectedRI, setSelectedRI] = useState(""); // Stores selected RI value
  const [selectedBookingId, setSelectedBookingId] = useState(null); // Stores the booking ID
  const [showDiscountModal, setShowDiscountModal] = useState(false);
  // const [selectedBooking, setSelectedBooking] = useState(null);
  const [discountPercentage, setDiscountPercentage] = useState("");
  const [discountReason, setDiscountReason] = useState("");

  const [isModalOpen, setIsModalOpen] = useState(false);
  //  const [selectedBooking, setSelectedBooking] = useState(null);
  const [isChecked, setIsChecked] = useState(false);
  const [damagedFile, setDamagedFile] = useState(null);
  const [electricityBill, setElectricityBill] = useState(null);

  const openModal = (booking) => {
    setSelectedBooking(booking);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedBooking(null);
    setIsChecked(false);
  };

  const openDiscountModal = (booking) => {
    setSelectedBooking(booking);
    setDiscountPercentage("");
    setDiscountReason("");
    setShowDiscountModal(true);
  };

  const openPopup = (bookingGroupId) => {
    setSelectedBookingId(bookingGroupId); // Store the ID for API call
    setShowPopup(true);
  };

  const closePopup = () => {
    setShowPopup(false);
    setSelectedRI(""); // Reset selection
  };

  const [showRemarksPopup, setShowRemarksPopup] = useState(false);
  const [showStatusPopup, setShowStatusPopup] = useState(false);
  // const [selectedBooking, setSelectedBooking] = useState(null);
  const [remarks, setRemarks] = useState("");
  const [attachment, setAttachment] = useState(null);
  const [eventStatus, setEventStatus] = useState("");
  const [discountFile, setDiscountFile] = useState("");
const [isDiscountApplicable, setIsDiscountApplicable] = useState("");
const [discountRemarks, setDiscountRemarks] = useState("");



  const handleFileChange = async (e, fileType) => {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("image", file); // Key should match backend (upload.single('image'))
    formData.append("fileType", fileType);

    try {
      const response = await fetch(`${host}/upload`, {
        method: "POST",
        body: formData,
      });

      if (!response.ok) {
        throw new Error("Upload failed");
      }

      const result = await response.json();

      if (result.location) {
        // ✅ Fix: Use "location" instead of "fileUrl"
        if (fileType === "damagedFile") {
          setDamagedFile(result.location); // ✅ Fix: Store the correct URL
          localStorage.setItem("damagedFile", result.location);
        } else if (fileType === "electricityBill") {
          setElectricityBill(result.location);
          localStorage.setItem("electricityBill", result.location);
        } else if (fileType === "discountFile") {
          setDiscountFile(result.location);
          localStorage.setItem("discountFile", result.location);
        }
        alert(`File uploaded successfully`);
      } else {
        throw new Error("Invalid file URL from server");
      }
    } catch (error) {
      console.error(`Error uploading ${fileType}:`, error);
      alert(`Error uploading ${fileType}`);
    }
  };

  // const openRemarksPopup = (booking) => {
  //   setSelectedBooking(booking);
  //   setRemarks(booking.remarks || "");
  //   setShowRemarksPopup(true);
  // };

  const openRemarksPopup = (booking) => {
  setSelectedBooking(booking);
  setRemarks(booking.remarks || "");
  setShowRemarksPopup(true);

  // Build per-date attachments array
  if (booking.dates) {
    const dateList = booking.dates.split(",");
    const initialized = dateList.map((d) => ({
      event_date: d.trim(),
      damagedAttachment: "",
      electricityAttachment: "",
      discountAttachment: "",
    }));
    setRemarksData(initialized);
  }
};


  const openStatusPopup = (booking) => {
    setSelectedBooking(booking);
    setEventStatus(booking.event_status || "");
    setShowStatusPopup(true);
  };

  // const handleRemarksSubmit = async () => {
  //   if (!remarks.trim()) {
  //     alert("Remarks cannot be empty!");
  //     return;
  //   }

  //   if (!isChecked) {
  //     alert("Please confirm the information before submitting.");
  //     return;
  //   }

  //   const userRole = localStorage.getItem("userRole");

  //   // ✅ Retrieve the correctly stored file URLs
  //   const damagedFileUrl = localStorage.getItem("damagedFile") || "";
  //   const electricityBillUrl = localStorage.getItem("electricityBill") || "";
  //   const discountFileUrl = localStorage.getItem("discountFile") || "";

  //   const payload = {
  //     booking_group_id: selectedBooking.booking_group_id,
  //     remark: remarks,
  //     added_by: userRole,
  //     action: "approved",
  //     attadamagedAttachment: damagedFileUrl, // ✅ Fix: Send correct URL
  //     electricityAttachment: electricityBillUrl, // ✅ Fix: Send correct URL
  //     discountAttachment: discountFileUrl,
  //         discount_applicable: isDiscountApplicable || "No",
  //   discount_remarks: discountRemarks || "",
  //   };

  //   console.log("Submitting Payload:", payload); // Debugging

  //   try {
  //     const response = await fetch(`${host}/update-post-booking-details`, {
  //       method: "POST",
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify(payload),
  //     });

  //     const result = await response.json();
  //     if (response.ok) {
  //       alert(result.message);
  //       localStorage.removeItem("damagedFile"); // ✅ Clear after submission
  //       localStorage.removeItem("electricityBill");
  //       localStorage.removeItem("discountFile");
  //       setShowRemarksPopup(false);
  //       window.location.reload();
  //     } else {
  //       alert("Failed to submit remarks: " + result.message);
  //     }
  //   } catch (error) {
  //     console.error("Error submitting remarks:", error);
  //     alert("An error occurred. Please try again.");
  //   }
  // };

// const handleRemarksSubmit = async () => {
//   if (!remarks.trim()) {
//     alert("Remarks cannot be empty!");
//     return;
//   }

//   if (!isChecked) {
//     alert("Please confirm the information before submitting.");
//     return;
//   }

//   const userRole = localStorage.getItem("userRole");

//   const damagedFileUrl = localStorage.getItem("damagedFile") || "";
//   const electricityBillUrl = localStorage.getItem("electricityBill") || "";
//   const discountFileUrl = localStorage.getItem("discountFile") || "";

//   const payload = {
//     booking_group_id: selectedBooking.booking_group_id,
//     remark: remarks,
//     added_by: userRole,
//     action: "approved",
//     attadamagedAttachment: damagedFileUrl,
//     electricityAttachment: electricityBillUrl,
//     discountAttachment: discountFileUrl,
//     discount_applicable: isDiscountApplicable || "No",
//     discount_remarks: discountRemarks || "",
//   };

//   try {
//     // 🔹 Step 1: NORMAL FLOW SUBMISSION (keep as-is)
//     const response = await fetch(`${host}/update-post-booking-details`, {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify(payload),
//     });

//     const result = await response.json();
//     if (!response.ok) {
//       alert("Failed to submit remarks: " + result.message);
//       return;
//     }

//     // 🔹 Step 2: IF DATE-WISE MODE, INSERT EACH DATE'S ATTACHMENT SEPARATELY
//     if (remarksMode === "breakdown" && remarksData.length > 0) {
//       for (const item of remarksData) {
//         const body = {
//           booking_group_id: selectedBooking.booking_group_id,
//           event_date: item.event_date,
//           damagedAttachment: item.damagedAttachment || null,
//           electricityAttachment: item.electricityAttachment || null,
//           discountAttachment: item.discountAttachment || null,
//           added_by: userRole,
//           remark: `Datewise Attachment (${moment(item.event_date).format("DD-MMM-YYYY")})`,
//         };

//         await fetch(`${host}/insert-datewise-attachments`, {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify(body),
//         });
//       }
//     }

//     alert("Remarks and all attachments submitted successfully!");
//     setShowRemarksPopup(false);
//     window.location.reload();

//   } catch (error) {
//     console.error("Error submitting remarks:", error);
//     alert("An error occurred while submitting. Please try again.");
//   }
// };


const handleRemarksSubmit = async () => {
  if (!remarks.trim()) {
    alert("Remarks cannot be empty!");
    return;
  }

  if (!isChecked) {
    alert("Please confirm the information before submitting.");
    return;
  }

  const userRole = localStorage.getItem("userRole");
    const tokenInfo = JSON.parse(localStorage.getItem("token-info") || "{}");
  const addedBy = tokenInfo.name || "Unknown User";


  // 🟢 Step 1: Combine URLs if in breakdown mode
  let combinedDamaged = localStorage.getItem("damagedFile") || "";
  let combinedElectricity = localStorage.getItem("electricityBill") || "";
  let combinedDiscount = localStorage.getItem("discountFile") || "";

  if (remarksMode === "breakdown" && remarksData.length > 0) {
    // Combine all URLs datewise, separated by commas
    const allDamaged = remarksData
      .map((d) => d.damagedAttachment)
      .filter(Boolean)
      .join(",");
    const allElectricity = remarksData
      .map((d) => d.electricityAttachment)
      .filter(Boolean)
      .join(",");
    const allDiscount = remarksData
      .map((d) => d.discountAttachment)
      .filter(Boolean)
      .join(",");

    if (allDamaged) combinedDamaged = allDamaged;
    if (allElectricity) combinedElectricity = allElectricity;
    if (allDiscount) combinedDiscount = allDiscount;
  }

  // 🟢 Step 2: Prepare main payload (for remarks table)
  const payload = {
    booking_group_id: selectedBooking.booking_group_id,
    remark: remarks,
    added_by: userRole,
    add_by: addedBy, 
    action: "approved",
    attadamagedAttachment: combinedDamaged,
    electricityAttachment: combinedElectricity,
    discountAttachment: combinedDiscount,
    discount_applicable: isDiscountApplicable || "No",
    discount_remarks: discountRemarks || "",
  };

  try {
    // 🔹 Step 3: NORMAL FLOW SUBMISSION (remarks table)
    const response = await fetch(`${host}/update-post-booking-details`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    const result = await response.json();
    if (!response.ok) {
      alert("Failed to submit remarks: " + result.message);
      return;
    }

    // 🔹 Step 4: DATE-WISE INSERTS (per-date table)
    if (remarksMode === "breakdown" && remarksData.length > 0) {
      for (const item of remarksData) {
        const body = {
          booking_group_id: selectedBooking.booking_group_id,
          event_date: item.event_date,
          damagedAttachment: item.damagedAttachment || null,
          electricityAttachment: item.electricityAttachment || null,
          discountAttachment: item.discountAttachment || null,
          added_by: userRole,
          add_by: addedBy,
          remark: `Datewise Attachment (${moment(item.event_date).format("DD-MMM-YYYY")})`,
        };

        await fetch(`${host}/insert-datewise-attachments`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(body),
        });
      }
    }

    alert("✅ Remarks and attachments submitted successfully!");
    setShowRemarksPopup(false);
    window.location.reload();
  } catch (error) {
    console.error("Error submitting remarks:", error);
    alert("An error occurred while submitting. Please try again.");
  }
};

  const handleStatusSubmit = () => {
    console.log("Event Status Updated:", eventStatus);
    console.log("Attachment:", attachment);
    setShowStatusPopup(false);
  };

  const handleApproval = async () => {
    if (!selectedRI) {
      alert("Please select an RI value before approving.");
      return;
    }

    try {
      console.log(" Sending request:", selectedBookingId, selectedRI);

      const response = await fetch(`${host}/approveBooking`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
        body: JSON.stringify({
          booking_group_id: selectedBookingId,
          ri_value: selectedRI,
        }),
      });

      console.log("⏳ Waiting for response...");

      if (!response.ok) {
        throw new Error("Failed to approve booking");
      }

      const updatedBooking = await response.json();
      console.log("✅ API Response:", updatedBooking);

      if (updatedBooking.success) {
        alert("Venue successfully approved!");
        myBookingsList();
        closePopup(); // Close modal
      } else {
        throw new Error("Approval failed");
      }
    } catch (error) {
      console.error("❌ Error approving booking:", error);
    }
  };

  const handleCancelClick = (booking) => {
    const cancellationReason = prompt("Please enter a cancellation reason:");

    if (!cancellationReason) {
      alert("Cancellation reason is required.");
      return;
    }

    cancelBooking(
      booking.booking_group_id,
      booking.date,
      cancellationReason
    ).then((success) => {
      if (success) {
        // Update UI only when the cancellation is successful
        setPaginatedBookingList((prevList) =>
          prevList.map((b) =>
            b.booking_group_id === booking.booking_group_id
              ? {
                  ...b,
                  status: "2",
                  cancelDisabled: true,
                  cancellation_reason: cancellationReason,
                }
              : b
          )
        );
      }
    });
  };

  const cancelBooking = async (
    bookingGroupId,
    bookingDate,
    cancellationReason
  ) => {
    let userRole = localStorage.getItem("userRole");

    if (!userRole) {
      console.error("User type not found in localStorage");
      alert("User type not found. Please log in again.");
      return false;
    }

    userRole = parseInt(userRole, 10);

    console.log("Cancel Booking Request:", {
      bookingGroupId,
      bookingDate,
      cancellationReason,
      userRole,
    });

    try {
      const response = await fetch(
        `${host}/cancelBooking?bookingGroupId=${bookingGroupId}&reason=${encodeURIComponent(
          cancellationReason
        )}&userRole=${userRole}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("access_token"),
          },
        }
      );

      const data = await response.json();
      console.log("Server Response:", data);

      if (response.ok) {
        alert(data.message);
        return true; // Indicate success
      } else {
        alert("Cancellation failed: " + data.message);
        return false;
      }
    } catch (error) {
      console.error("Cancellation Error:", error);
      alert("Cancellation failed. Please try again later.");
      return false;
    }
  };

  const handleModalClose = () => {
    setShowModal(false);
    setCancellationReason("");
    setSelectedBooking(null);
  };

  const handleModalSubmit = () => {
    if (!cancellationReason.trim()) {
      alert("Please provide a reason for cancellation.");
      return;
    }

    console.log("Cancellation reason:", cancellationReason); // Debugging
    cancelBooking(
      selectedBooking.booking_group_id,
      selectedBooking.date,
      cancellationReason
    );
    handleModalClose();
  };

  const handleApprove = async (bookingGroupId) => {
    if (!isChecked) {
      alert("Please confirm the details before approving.");
      return;
    }

    console.log("Approved Booking:", selectedBooking);

    try {
      console.log("Sending booking_group_id:", bookingGroupId); // Debugging

      const response = await fetch(`${host}/approveBooking`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
        body: JSON.stringify({ booking_group_id: bookingGroupId }), // Send in the body
      });

      if (!response.ok) {
        throw new Error("Failed to approve booking");
      }

      const updatedBooking = await response.json();

      if (updatedBooking.success) {
        alert("Venue successfully approved!"); // Show alert

        // 🔄 Re-fetch latest booking data after approval
        myBookingsList();

        closeModal();
      } else {
        throw new Error("Approval failed");
      }
    } catch (error) {
      console.error("Error approving booking:", error);
    }
  };

  const handlePageChange = (newPage) => {
    console.log("Page changed to:", newPage);
    setCurrentPage(newPage);

    const newPaginatedBookingList = bookingList.slice(
      (newPage - 1) * itemsPerPage,
      newPage * itemsPerPage
    );

    setPaginatedBookingList(newPaginatedBookingList);
  };

  const myBookingsListCallback = useCallback(() => {
    // myBookingsList();
  }, []);

  useEffect(() => {
    if (
      !localStorage.getItem("access_token") ||
      localStorage.getItem("access_token") === ""
    ) {
      navigate("/", "_self");
    }

    myBookingsListCallback();
    // myBookingsList();
  }, [currentPage, myBookingsListCallback]);

  let userRole = localStorage.getItem("userRole");
   const tokenInfo = JSON.parse(localStorage.getItem("token-info") || "{}");
const mobileNumber = tokenInfo.mobilenumber || "";
const userName = tokenInfo.name || "";

  let billingRequest = JSON.parse("{}");
  let srNo = 0;
  if (
    localStorage.getItem("access_token") == undefined ||
    localStorage.getItem("access_token") === ""
  ) {
    navigate("/", "_self");
  }

  // Add this inside your component function
  useEffect(() => {
    // console.log("Booking List:", bookingList);
  }, [bookingList]);

  const summaryView = (booking_group_id) => {
    fetch(
      host +
        "/getBookingSummary?bookingGroupId=" +
        booking_group_id +
        "&access_token=" +
        localStorage.getItem("access_token") +
        "&time=" +
        Math.round(new Date().getTime() / 1000),
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("access_token"),
        },
      }
    ).then((response) => {
      response.json().then((rooms) => {
        if (rooms.length === 0) {
          console.error("No rooms found");
          return;
        }

        let bookingDetailsDataFinal = [];
        const orderId = rooms[0].order_id;
        console.log("Order ID:", orderId);

        billingRequest.locationId = rooms[0].location_id;
        billingRequest.name = rooms[0].customer_name;
        billingRequest.address = rooms[0].address;
        billingRequest.contactno = rooms[0].contact_no;
        billingRequest.email = rooms[0].email_id;
        billingRequest.pan = rooms[0].pan_number;
        billingRequest.aadhaar = rooms[0].aadhaar_number;
        billingRequest.razorpay_status = rooms[0].razorpay_status;
        billingRequest.orderId = rooms[0].booking_id;
        billingRequest.bookingId = rooms[0].order_id;
        billingRequest.is_approved = rooms[0].is_approved;

        rooms.map((row) => {
          let tmpBookingDetailsDataFinal = JSON.parse("{}");
          tmpBookingDetailsDataFinal["room_name"] = row.room_name;
          tmpBookingDetailsDataFinal["bookingDate"] = row.date;
          tmpBookingDetailsDataFinal["amount"] = row.sub_total;
          tmpBookingDetailsDataFinal["selectedPersons"] = row.extra_persons;
          tmpBookingDetailsDataFinal["finalGrandTotalVal"] = row.sub_total;

          bookingDetailsDataFinal.push(tmpBookingDetailsDataFinal);
          console.log("Row Sub Total:", row.sub_total);
        });

        billingRequest.roomData = bookingDetailsDataFinal;
        localStorage.setItem("billingRequest", JSON.stringify(billingRequest));
        localStorage.setItem("bookingDetailsData", JSON.stringify("{}"));

        navigate("/BookingSummary", {
          state: {
            orderId: rooms[0].order_id,
            isApproved: rooms[0].is_approved,
          },
        });
      });
    });
  };

  console.log("tmpBookingDetailsDataFinal");
  const handleViewDocument = (fileUrl) => {
    if (!fileUrl) {
      alert("Document URL is not available.");
      return;
    }

    // Open the document in a new tab
    window.open(fileUrl, "_blank", "noopener,noreferrer");
  };

  const handleDateFileChange = async (e, index, type) => {
  const file = e.target.files[0];
  if (!file) return;

  const formData = new FormData();
  formData.append("file", file);

  try {
    const res = await fetch(`${host}/upload-attachment`, { method: "POST", body: formData });
    const data = await res.json();
    if (res.ok) {
      const updated = [...remarksData];
      updated[index][type] = data.fileUrl; // get URL from backend upload
      setRemarksData(updated);
    } else {
      alert("File upload failed: " + data.message);
    }
  } catch (err) {
    console.error("Upload error:", err);
  }
};

  const myBookingsList = async () => {
    try {
      const response = await fetch(
        host +
          "/getMyBookingsList?access_token=" +
          localStorage.getItem("access_token") +
          "&time=" +
          Math.round(new Date().getTime() / 1000),
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 403) {
        alert("Session expired. Please log in again.");
        localStorage.removeItem("access_token"); // Clear token
        navigate("/login", { replace: true }); // Redirect to login page
        return;
      }

      if (!response.ok) {
        throw new Error("Failed to fetch bookings");
      }

      const rooms = await response.json();
      // console.log(rooms, "rooms");

      if (!Array.isArray(rooms)) {
        throw new Error("Invalid response format");
      }

      let bookingListArray = [];
      let bookingListTmp = {};

      if (rooms.length === 0) {
        setNoData("No booking details available");
      }

      rooms.forEach((row) => {
        // Group by booking_group_id and room_id
        const roomKey = `${row.booking_group_id}-${row.room_id}`;

        if (bookingListTmp[roomKey] !== undefined) {
          let tmp = bookingListTmp[roomKey];
          tmp.room_names = tmp.room_names + ", " + row.accommodation_type;

          // Ensure the sub_total is added only once for the room
          // Only add if the sub_total is not already set for this room in the group
          if (!tmp.sub_total) {
            tmp.sub_total = row.sub_total;
          }
          bookingListTmp[roomKey] = tmp;
        } else {
          row.room_names = row.room_names;
          // Set sub_total once for each room in the booking group
          row.sub_total = row.sub_total;
          bookingListTmp[roomKey] = row;
        }
      });

      // Convert the object to an array
      Object.keys(bookingListTmp).forEach((key) => {
        bookingListArray.push(bookingListTmp[key]);
      });

      const updatedBookingList = bookingListArray.map((booking) => {
        const checkOutDate = moment(booking.date);
        const currentDate = moment();
        const isDateCompleted = currentDate.isAfter(checkOutDate, "day");

        return {
          ...booking,
          cancelDisabled: booking.status === "Canceled" || isDateCompleted,
        };
      });

      setBookingList(updatedBookingList);

      const newTotalPageCount = Math.ceil(
        updatedBookingList.length / itemsPerPage
      );
      setTotalPageCount(newTotalPageCount);

      // Update the paginated list based on the current page
      const newPaginatedBookingList = updatedBookingList.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
      );

      setPaginatedBookingList(newPaginatedBookingList);
      console.log(newPaginatedBookingList.map((rm) => rm));
      console.log(newPaginatedBookingList.map((rm) => rm.room_names));
      console.log("Total Page Count:", newTotalPageCount);
    } catch (error) {
      console.error("Error fetching bookings:", error);
      alert(
        "There was an error fetching your bookings. Please try again later."
      );
    }
  };

  const handleApplyDiscount = async () => {
    if (!discountPercentage || !discountReason) {
      alert("Please enter both discount percentage and reason.");
      return;
    }

    try {
      const response = await fetch(`${host}/applyDiscount`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
        body: JSON.stringify({
          booking_group_id: selectedBooking.booking_group_id,
          discount_percentage: discountPercentage,
          reason: discountReason,
        }),
      });

      const result = await response.json();

      if (result.success) {
        alert("Discount applied successfully!");
        setShowDiscountModal(false);
        // myBookingsList();
      } else {
        alert("Failed to apply discount.");
      }
    } catch (error) {
      console.error("Error applying discount:", error);
    }
  };

  const handleUpload = async () => {
    if (!electricityBill) {
      alert("Electricity Bill is required!");
      return;
    }

    const formData = new FormData();
    if (damagedFile) formData.append("damagedFile", damagedFile);
    formData.append("electricityBill", electricityBill);

    try {
      const response = await fetch(`${host}/upload`, {
        method: "POST",
        body: formData,
      });

      const result = await response.json();
      alert(result.message);
    } catch (error) {
      console.error("Error uploading files:", error);
    }
  };

  const handleRiChange = async (selectedRi, bookingGroupId) => {
    if (!selectedRi) return;

    try {
      const response = await fetch(`${host}/updateRoomBookingRI`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
        body: JSON.stringify({
          booking_group_id: bookingGroupId,
          ri_value: selectedRi,
        }),
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.message || "Failed to update RI value.");
      }

      alert("RI value updated successfully!"); // ✅ Alert before updating UI
      // myBookingsList();
      // 🔄 Immediately update UI to replace dropdown with text
      setBookingList((prevBookings) =>
        prevBookings.map((booking) =>
          booking.booking_group_id === bookingGroupId
            ? { ...booking, ri_value: selectedRi }
            : booking
        )
      );
    } catch (error) {
      console.error("Error updating RI value:", error);
      alert("Error updating RI value.");
    }
  };

    const [selectedRole, setSelectedRole] = useState("");
  const [appStatus, setAppStatus] = useState("");
  
  // 🔹 Role → App Status Mapping
  const roleToStatusMap = {
    RI: "Waiting for Remarks",
    AO: "waiting for AO approval",
    Secretary: "waiting for comm-sec approval",
    CAO: "Waiting for CAO verification approval",
    "CAO-AO": "Waiting for CAO-AO Approval",
  };
  
  // 🔹 Handle Role Change
  const handleRoleChange = (e) => {
    const role = e.target.value;
    setSelectedRole(role);
    setAppStatus(roleToStatusMap[role] || "");
  };
  
  // 🔹 Updated Reassign API Call
  // const handleReassign = async () => {
  //   if (!selectedRole) {
  //     alert("Please select a role to reassign.");
  //     return;
  //   }
  
  //   try {
  //     const response = await fetch(`${host}/reassign`, {
  //       method: "POST",
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify({
  //         booking_group_id: selectedBooking.booking_group_id,
  //         remarks: remarks,
  //         added_by: userRole, // logged in role
  //         reassign_to: selectedRole,
  //         app_status: appStatus, // 🔹 now we pass the correct app_status automatically
  //       }),
  //     });
  
  //     const data = await response.json();
  //     if (response.ok) {
  //       alert(data.message);
  //       setShowDiscountModal(false);
  //     } else {
  //       alert(data.message || "Failed to reassign");
  //     }
  //   } catch (error) {
  //     console.error("Error reassigning:", error);
  //     alert("Something went wrong");
  //   }
  // };

  const handleReassign = async () => {
  if (!selectedRole) {
    alert("Please select a role to reassign.");
    return;
  }

  const userRole = localStorage.getItem("userRole");

  // ✅ Retrieve attachments from localStorage (if uploaded earlier)
  const damagedFileUrl = localStorage.getItem("damagedFile") || null;
  const electricityBillUrl = localStorage.getItem("electricityBill") || null;
  const discountFileUrl = localStorage.getItem("discountFile") || null;

  try {
    const response = await fetch(`${host}/reassign`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        booking_group_id: selectedBooking.booking_group_id,
        remarks: remarks,
        added_by: userRole,    
             // logged in role
        reassign_to: selectedRole,  // new role
        app_status: appStatus,      // correct app_status
        damagedAttachment: damagedFileUrl,
        electricityAttachment: electricityBillUrl,
        discountAttachment: discountFileUrl
      }),
    });

    const data = await response.json();
    if (response.ok) {
      alert(data.message);

      // ✅ Clear attachments after successful reassign
      localStorage.removeItem("damagedFile");
      localStorage.removeItem("electricityBill");
      localStorage.removeItem("discountFile");

      setShowDiscountModal(false);
      window.location.reload();
    } else {
      alert(data.message || "Failed to reassign");
    }
  } catch (error) {
    console.error("Error reassigning:", error);
    alert("Something went wrong");
  }
};


  const [totalPageCount, setTotalPageCount] = useState(1);

  const bookingSummary = () => {};

  const refreahData = () => {
    // myBookingsList();
  };

  const [filters, setFilters] = useState({
    checkInDate: "",
    bookingDate: "",
    customerName: "",
    venueName: "",
    status: "",
  });

  // const handleFilterChange = (e) => {
  //   setFilters({ ...filters, [e.target.name]: e.target.value });
  // };

  const handleFilterChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
    setCurrentPage(1); // optional: reset to first page on filter change
  };
  // const filteredBookings = bookingList.filter((rm) => {
  //   return (
  //     (!filters.checkInDate ||
  //       moment(rm.date).format("DD-MMM-YYYY") ===
  //         moment(filters.checkInDate).format("DD-MMM-YYYY")) && // Filter by check-in date
  //     (!filters.bookingDate ||
  //       moment(rm.booking_date).format("DD-MMM-YYYY") ===
  //         moment(filters.bookingDate).format("DD-MMM-YYYY")) && // Filter by booking date
  //     (!filters.customerName ||
  //       rm.customer_name
  //         .toLowerCase()
  //         .includes(filters.customerName.toLowerCase())) &&
  //     (!filters.venueName ||
  //       rm.room_names
  //         .toLowerCase()
  //         .includes(filters.venueName.toLowerCase())) &&
  //     (!filters.status || rm.status.toString() === filters.status)
  //   );
  // });
 
   const filteredBookings = bookingList.filter((rm) => {
  return (
    (!filters.checkInDate ||
      rm.dates?.split(",").some(
        (d) =>
          moment(d).format("DD-MMM-YYYY") ===
          moment(filters.checkInDate).format("DD-MMM-YYYY")
      )) &&
    (!filters.bookingDate ||
      moment(rm.booking_date).format("DD-MMM-YYYY") ===
        moment(filters.bookingDate).format("DD-MMM-YYYY")) &&
    (!filters.customerName ||
      rm.customer_name
        ?.toLowerCase()
        .includes(filters.customerName.toLowerCase())) &&
    (!filters.venueName ||
      rm.room_names
        ?.toLowerCase()
        .includes(filters.venueName.toLowerCase())) &&
    (!filters.app_status ||
      (rm.app_status || "")
        .toLowerCase()
        .includes(filters.app_status.toLowerCase()))
  );
});
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;

  const paginatedFilteredBookings = filteredBookings.slice(
    startIndex,
    endIndex
  );

  useEffect(() => {
    myBookingsList();
    myBookingsListCallback();
  }, [currentPage]);
  const onChangeLocation = () => {
    // myBookingsList();
    // populateAvailableRoomsInCalender(moment(nextDates[0]).format("DD-MMM-YYYY"));
    //checkAvailability();
  };
  return (
    <div>
      <Header />
      {/* <Navbar /> */}
      <div className="container-fluid">
        <div className="row">
          {/* <div className="col-lg-2"></div> */}
          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12  content_back">
            <div className="row">
              <b>Booking Details</b>
            </div>

            <div className="filter-container">
              <div className="filter-item">
                <label>Event Date:</label>
                <input
                  type="date"
                  name="checkInDate"
                  value={filters.checkInDate}
                  onChange={handleFilterChange}
                />
              </div>
              <div className="filter-item">
                <label>Booking Date:</label>
                <input
                  type="date"
                  name="bookingDate"
                  value={filters.bookingDate}
                  onChange={handleFilterChange}
                />
              </div>

              <div className="filter-item">
                <label>Customer Name:</label>
                <input
                  type="text"
                  name="customerName"
                  value={filters.customerName}
                  onChange={handleFilterChange}
                  placeholder="Enter Customer Name"
                />
              </div>

              <div className="filter-item">
                <label>Venue Name:</label>
                <input
                  type="text"
                  name="venueName"
                  value={filters.venueName}
                  onChange={handleFilterChange}
                  placeholder="Enter Venue Name"
                />
              </div>
            </div>
            <div className="row" style={{ overflowX: "auto" }}>
              <table className="table table-striped responsive-table">
                <thead>
                  <tr
                    className="data-row-head"
                    style={{ whiteSpace: "nowrap" }}
                  >
                    <th>S No</th>
                    <th>Venue Details</th>
                    <th>Venue Type</th>
                    <th>Event Date</th>
                    <th>Contact Name</th>
                    <th>Contact No</th>
                    <th>Amount</th>
                    <th>Remarks</th>
                    <th>Event Status</th>
                    <th>Refund Status</th>
                    <th>Electricity Attachment</th>
                    <th>Damaged Attachment</th>
                    <th>Discount Attachment</th>

                    <th>Booking Date</th>
                    <th>Cancel</th>
                    <th>Reassign Status</th>
                  </tr>
                </thead>
                <tbody style={{ whiteSpace: "nowrap" }}>
                  {paginatedFilteredBookings.map((rm, index) => (
                    <tr key={rm.booking_group_id} className={`data-row-data ${
    rm.app_status?.toLowerCase() == "refund successfully approved"
      ? "refund-success"
      : ""
  }`}>
                      {/* <td style={{ textAlign: "center" }}>{index + 1}</td> */}
                      <td style={{ textAlign: "center" }}>
                        {(currentPage - 1) * itemsPerPage + index + 1}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {rm.accommodation_type}
                      </td>
                      <td style={{ textAlign: "center" }}>{rm.room_names}</td>
                      {/* <td style={{ textAlign: "center" }}>
                        {moment(rm.date).format("DD-MMM-YYYY")}
                      </td> */}

                                           <td style={{ textAlign: "center" }}>
  {rm.dates
    ? (() => {
        const arr = rm.dates.split(",").map(d => moment(d).format("DD-MMM-YYYY"));
        return arr.length === 1 ? arr[0] : `${arr[0]} to ${arr[arr.length - 1]}`;
      })()
    : "-"}
</td>
                      <td style={{ textAlign: "center" }}>
                        {rm.customer_name}
                      </td>
                      <td style={{ textAlign: "center" }}>{rm.contact_no}</td>
                      <td style={{ textAlign: "center" }}>{rm.sub_total}</td>

                      {/* Remarks Column (Editable for UserRole 5) */}

                      <td style={{ textAlign: "center" }}>
                        {rm.remarks}
                        {rm.app_status === "Waiting for Remarks" && (
                          <i
                            className="fa fa-edit"
                            onClick={() => openRemarksPopup(rm)}
                            style={{
                              cursor: "pointer",
                              marginLeft: "10px",
                              color: "blue",
                            }}
                          ></i>
                        )}
                      </td>

                      {/* Event Status Column (Dropdown for UserRole 5) */}

                      <td>{rm.event_status}</td>
                      <td>{rm.app_status}</td>
                      {/* <td style={{ textAlign: "center" }}>
                        {rm.reviews &&
                        rm.reviews.length > 0 &&
                        rm.reviews[0].electricityAttachment ? (
                          <a
                            href={rm.reviews[0].electricityAttachment}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            View
                          </a>
                        ) : (
                          ""
                        )}
                      </td>

                      <td style={{ textAlign: "center" }}>
                        {rm.reviews &&
                        rm.reviews.length > 0 &&
                        rm.reviews[0].damagedAttachment ? (
                          <a
                            href={rm.reviews[0].damagedAttachment}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            View
                          </a>
                        ) : (
                          ""
                        )}
                      </td> */}

                          <td style={{ textAlign: "center" }}>
                        {rm.reviews &&
                        rm.reviews.length > 0 &&
                        rm.reviews[0].electricityAttachment ? (
                          <a
                            href={rm.reviews[0].electricityAttachment}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            View
                          </a>
                        ) : (
                          ""
                        )}
                      </td>

                      <td style={{ textAlign: "center" }}>
                        {rm.reviews &&
                        rm.reviews.length > 0 &&
                        rm.reviews[0].damagedAttachment ? (
                          <a
                            href={rm.reviews[0].damagedAttachment}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            View
                          </a>
                        ) : (
                          ""
                        )}
                      </td>

                        <td style={{ textAlign: "center" }}>
    {rm.discount_attachment ? (
      <a
        href={rm.discount_attachment}
        target="_blank"
        rel="noopener noreferrer"
      >
        View
      </a>
    ) : (
      ""
    )}
  </td>

                      <td style={{ textAlign: "center" }}>
                        {moment(rm.booking_date).format("DD-MMM-YYYY")}{" "}
                      </td>

                       <td>
                        <button
                          // onClick={() => handleCancelClick(rm)}
                          disabled={rm.cancelDisabled || rm.status === 2}
                          className={
                            "view-document-button " +
                            (rm.cancelDisabled || rm.status === 2
                              ? "disabledButton"
                              : "")
                          }
                          style={{
                            padding: "6px",
                            background: "#d20909e8",
                            border: "none",
                            borderRadius: "4px",
                            color: "#fff",
                          }}
                        >
                          {rm.status === 2 ? "cancelled" : "Cancel"}
                        </button>
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {rm.reassign_status || ""} </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              {/* Remarks original Popup and also rejection process */}

              {showRemarksPopup && selectedBooking && (
                <div className="modal-overlay">
                  <div className="modal-container" style={{width:"80%"}}>
                    {/* Modal Header */}
                    <div className="modal-header">
                      <h2 className="modal-title"> Remarks</h2>
                      <button
                        type="button"
                        className="close-btn"
                        onClick={() => setShowRemarksPopup(false)}
                      >
                        ✖
                      </button>
                    </div>

                    {/* Modal Body */}
                    <div className="modal-content">
                      <div className="row">
                        <div className="col-4">
                          <p>
                            <strong>Venue :</strong>
                          </p>
                          <span className="roomnames">
                            {selectedBooking.accommodation_type || "N/A"}
                          </span>
                        </div>
                        <div className="col-4">
                          <p>
                            <strong>Venue Type :</strong>
                          </p>
                          <span className="roomnames">
                            {selectedBooking.room_names || "N/A"}
                          </span>
                        </div>
                        <div className="col-4">
                          <p>
                            <strong>Event Date :</strong>
                          </p>
                          <span className="roomnames">
                            {/* {moment(selectedBooking.date).format("DD-MMM-YYYY")} */}
                             {selectedBooking.dates
    ? (() => {
        const arr = selectedBooking.dates.split(",").map(d => moment(d).format("DD-MMM-YYYY"));
        return arr.length === 1 ? arr[0] : `${arr[0]} to ${arr[arr.length - 1]}`;
      })()
    : "-"}
                          </span>
                        </div>
                      </div>

                      {/* Second Line: Customer Name, Phone, Email */}
                      <div className="row">
                        <div className="col-4">
                          <p>
                            <strong>Name:</strong>
                          </p>
                          <span className="roomnames">
                            {selectedBooking.customer_name || "N/A"}
                          </span>
                        </div>
                        <div className="col-4">
                          <p>
                            <strong>Phone:</strong>
                          </p>
                          <span className="roomnames">
                            {selectedBooking.contact_no || "N/A"}
                          </span>
                        </div>
                        <div className="col-4">
                          <p>
                            <strong>Email:</strong>
                          </p>
                          <span className="roomnames">
                            {selectedBooking.email || "N/A"}
                          </span>
                        </div>
                      </div>

                        
                    <table className="table table-responsive">
                      <thead>
                        <tr>
                          <th>Rent</th>
                          <th>GST</th>
                          <th>Security Deposit</th>
                          <th>Cleaning Charges</th>
                          <th>Total Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>₹{selectedBooking.total_rent}</td>
                          <td>₹{selectedBooking.total_gst}</td>
                          <td>₹{selectedBooking.total_security_deposit}</td>
                          <td>₹{selectedBooking.total_cleaning_charges}</td>
                          <td>₹{selectedBooking.sub_total}</td>
                        </tr>
                      </tbody>
                    </table>
<div style={{ marginBottom: "15px" }}>
  <label style={{ fontWeight: "bold", marginRight: "15px" }}>Remarks Type:</label>
  <label style={{ marginRight: "20px" }}>
    <input
      type="radio"
      name="remarksMode"
      value="normal"
      checked={remarksMode === "normal"}
      onChange={() => setRemarksMode("normal")}
    />{" "}
    Normal
  </label>
  <label>
    <input
      type="radio"
      name="remarksMode"
      value="breakdown"
      checked={remarksMode === "breakdown"}
      onChange={() => setRemarksMode("breakdown")}
    />{" "}
    Date-wise Attachments
  </label>
</div>
{remarksMode === "breakdown" && (
  <>
    <h4 style={{ marginTop: "15px" }}>Date-wise Attachments</h4>
    <table className="table table-responsive">
      <thead>
        <tr>
          <th>Date</th>
          <th>Damaged</th>
          <th>Electricity</th>
          <th>Discount</th>
        </tr>
      </thead>
      <tbody>
        {remarksData.map((row, index) => (
          <tr key={index}>
            <td>{moment(row.event_date).format("DD-MMM-YYYY")}</td>

            <td>
              {row.damagedAttachment ? (
                <a href={row.damagedAttachment} target="_blank" rel="noopener noreferrer">View</a>
              ) : (
                <input
                  type="file"
                  onChange={(e) => handleDateFileChange(e, index, "damagedAttachment")}
                />
              )}
            </td>

            <td>
              {row.electricityAttachment ? (
                <a href={row.electricityAttachment} target="_blank" rel="noopener noreferrer">View</a>
              ) : (
                <input
                  type="file"
                  onChange={(e) => handleDateFileChange(e, index, "electricityAttachment")}
                />
              )}
            </td>

            <td>
              {row.discountAttachment ? (
                <a href={row.discountAttachment} target="_blank" rel="noopener noreferrer">View</a>
              ) : (
                <input
                  type="file"
                  onChange={(e) => handleDateFileChange(e, index, "discountAttachment")}
                />
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </>
)}

                      

                      <div className="row">
                        <div className="col-12">
                          <p>
                            <strong>Remarks:</strong>
                          </p>
                          <textarea
                            value={remarks}
                            onChange={(e) => setRemarks(e.target.value)}
                            placeholder="Enter remarks..."
                            rows={4}
                            className="remarks-input"
                            style={{ width: "inherit" }}
                          />
                        </div>
                      </div>

                      {selectedBooking.file_url && (
                        <div className="row">
                          <div className="col-12">
                            <span>
                              <strong>Attachment of Proof &nbsp;:</strong>
                            </span>
                            <a href={selectedBooking.file_url} target="_blank">
                              &nbsp; view
                            </a>
                          </div>
                        </div>
                      )}

                      {/* <div className="row">
                        <div className="col-4">
                          <p>
                            <strong>Attach Damaged Files:</strong>
                          </p>
                          <input
                            type="file"
                            className="file-input"
                            onChange={(e) => handleFileChange(e, "damagedFile")}
                          />
                        </div>
                        <div className="col-4">
                          <p>
                            <strong>Attach Electricity Bill:</strong>
                          </p>
                          <input
                            type="file"
                            onChange={(e) =>
                              handleFileChange(e, "electricityBill")
                            }
                            className="file-input"
                          />
                        </div>
                        <div className="col-4">
                          <p>
                            <strong>Attach Discount Proof:</strong>
                          </p>
                       
                          {selectedBooking.discount_attachment ? (
                            <a
                              href={selectedBooking.discount_attachment}
                              download
                              className="view-document-button"
                              style={{ display: "block", marginTop: "5px" }}
                            >
                              View Attachment
                            </a>
                          ) : (
                            <input
                              type="file"
                              accept=".jpg,.jpeg,.png,.pdf"
                              className="file-input"
                              onChange={(e) =>
                                handleFileChange(e, "discountFile")
                              }
                              style={{ display: "block", marginTop: "5px" }}
                            />
                          )}
                        </div>
                      </div> */}

                      {remarksMode === "normal" && (
  <>
    <div className="row">
      <div className="col-4">
        <p>
          <strong>Attach Damaged Files:</strong>
        </p>
        <input
          type="file"
          className="file-input"
          onChange={(e) => handleFileChange(e, "damagedFile")}
        />
      </div>
      <div className="col-4">
        <p>
          <strong>Attach Electricity Bill:</strong>
        </p>
        <input
          type="file"
          onChange={(e) => handleFileChange(e, "electricityBill")}
          className="file-input"
        />
      </div>
      <div className="col-4">
        <p>
          <strong>Attach Discount Proof:</strong>
        </p>
        {selectedBooking.discount_attachment ? (
          <a
            href={selectedBooking.discount_attachment}
            download
            className="view-document-button"
            style={{ display: "block", marginTop: "5px" }}
          >
            View Attachment
          </a>
        ) : (
          <input
            type="file"
            accept=".jpg,.jpeg,.png,.pdf"
            className="file-input"
            onChange={(e) => handleFileChange(e, "discountFile")}
            style={{ display: "block", marginTop: "5px" }}
          />
        )}
      </div>
    </div>
  </>
)}


   <div className="row">
  {/* Discount Applicable Dropdown */}
  <div className="col-6">
    <p>
      <strong>Discount Applicable:</strong>
    </p>
    <select
      value={isDiscountApplicable}
      onChange={(e) => setIsDiscountApplicable(e.target.value)}
      className="popup-input"
      style={{ width: "100%" }}
    >
      <option value="">Select</option>
      <option value="Yes">Yes</option>
      <option value="No">No</option>
    </select>
  </div>

  {/* Remarks → show only when Yes */}
  {isDiscountApplicable === "Yes" && (
    <div className="col-6">
      <p>
        <strong>Remarks:</strong>
      </p>
      <textarea
        value={discountRemarks}
        onChange={(e) => setDiscountRemarks(e.target.value)}
        placeholder="Enter discount % , amount, and remarks..."
        rows={4}
        className="remarks-input"
        style={{ width: "100%" }}
      />
    </div>
  )}
</div>

 <div className="row mt-3">
                      <div className="col-12">
                        <h6 style={{ marginBottom: "8px", color: "#007bff" }}>
                         Reassign Remarks (OR) Remarks History
                        </h6>

                        <div
                          style={{
                            maxHeight: "200px",
                            overflowY: "auto",
                            border: "1px solid #ddd",
                            borderRadius: "6px",
                            padding: "10px",
                            background: "#f9f9f9",
                          }}
                        >
                          {(() => {
                            const allRemarks = [];

                            if (selectedBooking?.refund_details && Array.isArray(selectedBooking.refund_details) && selectedBooking.refund_details.length) {
                              selectedBooking.refund_details.forEach((r) => {
                                allRemarks.push({
                                  role: "AO",
                                  date: r.refunded_at,
                                  comment: r.refund_reason,
                                });
                              });
                            }

                            if (selectedBooking?.cao_remarks && Array.isArray(selectedBooking.cao_remarks) && selectedBooking.cao_remarks.length) {
                              selectedBooking.cao_remarks.forEach((r) => {
                                allRemarks.push({
                                  role: "CAO",
                                  date: r.created,
                                  comment: r.cao_remarks,
                                });
                              });
                            }

                            if (selectedBooking?.cao_ao_remarks && Array.isArray(selectedBooking.cao_ao_remarks) && selectedBooking.cao_ao_remarks.length) {
                              selectedBooking.cao_ao_remarks.forEach((r) => {
                                allRemarks.push({
                                  role: "CAO-AO",
                                  date: r.created,
                                  comment: r.cao_ao_remarks,
                                });
                              });
                            }

                            if (selectedBooking?.commisioner_remarks && Array.isArray(selectedBooking.commisioner_remarks) && selectedBooking.commisioner_remarks.length) {
                              selectedBooking.commisioner_remarks.forEach(
                                (r) => {
                                  allRemarks.push({
                                    role: "Secretary",
                                    date: r.created,
                                    comment: r.sec_remarks,
                                  });
                                }
                              );
                            }

                            if (selectedBooking?.reviews && Array.isArray(selectedBooking.reviews) && selectedBooking.reviews.length) {
                              selectedBooking.reviews.forEach((r) => {
                                allRemarks.push({
                                  role: "RI",
                                  date: r.created,
                                  comment: r.remark,
                                });
                              });
                            }

                            return allRemarks.length > 0 ? (
                              allRemarks
                                .sort(
                                  (a, b) => new Date(b.date) - new Date(a.date)
                                )
                                .map((remark, index) => (
                                  <div
                                    key={index}
                                    style={{
                                      marginBottom: "10px",
                                      paddingBottom: "8px",
                                      borderBottom: "1px dashed #ccc",
                                    }}
                                  >
                                    <p style={{ margin: "0 0 4px" }}>
                                      <strong>
                                        {moment(remark.date).format(
                                          "DD-MMM-YYYY"
                                        )}
                                        , {remark.role}
                                      </strong>
                                    </p>
                                    <p style={{ margin: 0 }}>
                                      {remark.comment || "N/A"}
                                    </p>
                                  </div>
                                ))
                            ) : (
                              <p>No remarks available</p>
                            );
                          })()}
                        </div>
                      </div>
                    </div>


                      <div className="form-check">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="confirmCheck"
                          checked={isChecked}
                          onChange={(e) => setIsChecked(e.target.checked)}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="confirmCheck"
                        >
                          I have checked and confirmed that the information is
                          correct.
                        </label>
                      </div>
                    </div>

                    {/* Modal Actions */}
                    <div className="modal-actions">
                      <button
                        onClick={handleRemarksSubmit}
                        className="approve-btn"
                      >
                        Submit To AO
                      </button>
                      {/* <button
                        onClick={() => setShowRemarksPopup(false)}
                        className="cancel-btn"
                      >
                        Cancel
                      </button> */}

                        <select
  value={selectedRole}
  onChange={handleRoleChange}
  className="popup-input" style={{width:"30% !important"}}
>
  <option value="">Select Role to Reassign</option>
  <option value="RI">RI</option>
  <option value="AO">AO</option>
  <option value="Secretary">Secretary</option>
  <option value="CAO">CAO</option>
  <option value="CAO-AO">CAO-AO</option>
</select>

{/* 🔹 Show app status preview */}
{appStatus && (
  <p style={{ marginTop: "6px", fontStyle: "italic", color: "#666" }}>
    New Status: {appStatus}
  </p>
)}

<button onClick={handleReassign} className="cancelButton">
  Reassign
</button>
                    </div>
                  </div>
                </div>
              )}

              {/* Event Status Popup (Waiting for Remarks) */}
              {showStatusPopup && selectedBooking && (
                <div className="modal-overlay">
                  <div className="modal-container">
                    {/* Modal Header */}
                    <div className="modal-header">
                      <h2 className="modal-title"> Remarks</h2>
                      <button
                        type="button"
                        className="close-btn"
                        onClick={() => setShowStatusPopup(false)}
                      >
                        ✖
                      </button>
                    </div>

                    {/* Modal Body */}
                    <div className="modal-content">
                      <div className="row">
                        <div className="col-4">
                          <p>
                            <strong>Venue :</strong>
                          </p>
                          <span className="roomnames">
                            {selectedBooking.accommodation_type || "N/A"}
                          </span>
                        </div>
                        <div className="col-4">
                          <p>
                            <strong>Venue Type :</strong>
                          </p>
                          <span className="roomnames">
                            {selectedBooking.room_names || "N/A"}
                          </span>
                        </div>
                        <div className="col-4">
                          <p>
                            <strong>Event Date :</strong>
                          </p>
                          <span className="roomnames">
                            {moment(selectedBooking.date).format("DD-MMM-YYYY")}
                          </span>
                        </div>
                      </div>

                      {/* Second Line: Customer Name, Phone, Email */}
                      <div className="row">
                        <div className="col-4">
                          <p>
                            <strong>Name:</strong>
                          </p>
                          <span className="roomnames">
                            {selectedBooking.customer_name || "N/A"}
                          </span>
                        </div>
                        <div className="col-4">
                          <p>
                            <strong>Phone:</strong>
                          </p>
                          <span className="roomnames">
                            {selectedBooking.contact_no || "N/A"}
                          </span>
                        </div>
                        <div className="col-4">
                          <p>
                            <strong>Email:</strong>
                          </p>
                          <span className="roomnames">
                            {selectedBooking.email || "N/A"}
                          </span>
                        </div>
                      </div>

                      {/* Event Name */}

                      {/* Purpose & Proof Attachment */}
                      <div className="row">
                        <div className="col-12">
                          <span>
                            <strong>Concession Type &nbsp;:</strong>
                          </span>
                          <span>&nbsp; {selectedBooking.purpose || "N/A"}</span>
                        </div>
                      </div>

                      {/* Assigned to RI */}
                      <div className="row">
                        <div className="col-12">
                          <span>
                            <strong>Assigned to &nbsp;:</strong>
                          </span>
                          <span>
                            &nbsp; {selectedBooking.ri_value || "Not Assigned"}
                          </span>
                        </div>
                      </div>

                      {/* Remarks Input Field */}
                      <div className="row">
                        <div className="col-12">
                          <p>
                            <strong>Remarks:</strong>
                          </p>
                          <textarea
                            value={remarks}
                            onChange={(e) => setRemarks(e.target.value)}
                            placeholder="Enter remarks..."
                            rows={4}
                            className="remarks-input"
                            style={{ width: "inherit" }}
                          />
                        </div>
                      </div>

                      {/* File Attachment */}
                      <div className="row">
                        <div className="col-12">
                          <p>
                            <strong>Attach Damaged Files:</strong>
                          </p>
                          <input
                            type="file"
                            multiple
                            onChange={(e) => setAttachment(e.target.files[0])}
                            className="file-input"
                          />
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-12">
                          <p>
                            <strong>Attach Electricity Bill:</strong>
                          </p>
                          <input
                            type="file"
                            onChange={(e) => setAttachment(e.target.files[0])}
                            className="file-input"
                          />
                        </div>
                      </div>
                    </div>

                    {/* Modal Actions */}
                    <div className="modal-actions">
                      <button
                        onClick={handleStatusSubmit}
                        className="approve-btn"
                      >
                        Submit
                      </button>
                      <button
                        onClick={() => setShowStatusPopup(false)}
                        className="cancel-btn"
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>

            {showModal && (
              <div className="modal-overlay">
                <div className="modal-content">
                  <h3>Reason for Cancellation</h3>
                  <textarea
                    value={cancellationReason}
                    onChange={(e) => setCancellationReason(e.target.value)}
                    placeholder="Enter reason for cancellation"
                    rows="4"
                    style={{ width: "100%" }}
                  />
                  <div style={{ marginTop: "10px" }}>
                    <button
                      onClick={handleModalSubmit}
                      style={{ marginRight: "10px" }}
                    >
                      Submit
                    </button>
                    <button onClick={handleModalClose}>Cancel</button>
                  </div>
                </div>
              </div>
            )}

            {showPopup && (
              <div className="popup-overlay">
                <div className="popup-content">
                  <h3>Allot To RI</h3>
                  <div class="form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      value="RI1"
                      checked={selectedRI === "RI1"}
                      onChange={() => setSelectedRI("RI1")}
                    />
                    <label className="form-check-label">RI1</label>
                  </div>
                  <div class="form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      value="RI2"
                      checked={selectedRI === "RI2"}
                      onChange={() => setSelectedRI("RI2")}
                    />
                    <label className="form-check-label">RI2</label>
                  </div>
                  <div class="form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      value="RI3"
                      checked={selectedRI === "RI3"}
                      onChange={() => setSelectedRI("RI3")}
                    />
                    <label className="form-check-label">RI3</label>
                  </div>
                  <div className="popup-buttons">
                    {/* <button onClick={handleApproval} className="approveButton">
                      Approve
                    </button> */}

                    <button
                      type="button"
                      onClick={handleApproval}
                      className="approveButton"
                    >
                      Approve
                    </button>

                    <button onClick={closePopup} className="cancelButton">
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            )}

            {showDiscountModal && selectedBooking && (
              <div className="popup-overlay">
                <div className="popup-content">
                  <h3>Apply Discount</h3>
                  <p>
                    <strong>Name:</strong> {selectedBooking.customer_name}
                  </p>
                  <p>
                    <strong>Mobile No:</strong> {selectedBooking.contact_no}
                  </p>
                  <p>
                    <strong>Amount:</strong> Rs.{selectedBooking.sub_total}
                  </p>

                  <label>Discount Percentage (%):</label>
                  <input
                    type="number"
                    value={discountPercentage}
                    onChange={(e) => setDiscountPercentage(e.target.value)}
                    min="0"
                    max="100"
                  />

                  <label>Reason:</label>
                  <textarea
                    value={discountReason}
                    onChange={(e) => setDiscountReason(e.target.value)}
                  />

                  <div className="popup-buttons">
                    <button
                      onClick={handleApplyDiscount}
                      className="approveButton"
                    >
                      Apply Discount
                    </button>
                    <button
                      onClick={() => setShowDiscountModal(false)}
                      className="cancelButton"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            )}

            {isModalOpen && selectedBooking && (
              <div className="modal-overlay">
                <div className="modal-container">
                  {/* Modal Header */}
                  <div className="modal-header">
                    <h2 className="modal-title">Approve Booking</h2>
                    <button
                      type="button"
                      className="close-btn"
                      onClick={closeModal}
                    >
                      ✖
                    </button>
                  </div>

                  {/* Modal Body */}
                  <div className="modal-content">
                    {/* First Line: Venue Name & Event Date */}
                    <div className="row">
                      <div className="col-4">
                        <p>
                          <strong>Venue :</strong>
                        </p>
                        <span className="roomnames">
                          {selectedBooking.accommodation_type || "N/A"}
                        </span>
                      </div>
                      <div className="col-4">
                        <p>
                          <strong>Venue Type :</strong>
                        </p>
                        <span className="roomnames">
                          {selectedBooking.room_names || "N/A"}
                        </span>
                      </div>
                      <div className="col-4">
                        <p>
                          <strong>Event Date :</strong>
                        </p>
                        <span className="roomnames">
                          {moment(selectedBooking.date).format("DD-MMM-YYYY")}
                        </span>
                      </div>
                    </div>

                    {/* Second Line: Customer Name, Phone, Email */}
                    <div className="row">
                      <div className="col-4">
                        <p>
                          <strong>Name:</strong>
                        </p>
                        <span className="roomnames">
                          {selectedBooking.customer_name || "N/A"}
                        </span>
                      </div>
                      <div className="col-4">
                        <p>
                          <strong>Phone:</strong>
                        </p>
                        <span className="roomnames">
                          {selectedBooking.contact_no || "N/A"}
                        </span>
                      </div>
                      <div className="col-4">
                        <p>
                          <strong>Email:</strong>
                        </p>
                        <span className="roomnames">
                          {selectedBooking.email || "N/A"}
                        </span>
                      </div>
                    </div>

                    {/* Third Line: Tabular Format for Rent, GST, etc. */}
                    <table className="table">
                      <thead>
                        <tr>
                          <th>Rent</th>
                          <th>GST</th>
                          <th>Security Deposit</th>
                          <th>Cleaning Charges</th>
                          <th>Total Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>₹{selectedBooking.total_rent}</td>
                          <td>₹{selectedBooking.total_gst}</td>
                          <td>₹{selectedBooking.total_security_deposit}</td>
                          <td>₹{selectedBooking.total_cleaning_charges}</td>
                          <td>₹{selectedBooking.sub_total}</td>
                        </tr>
                      </tbody>
                    </table>

                    {/* Purpose & Proof Attachment */}
                    <div className="row">
                      <div className="col-12">
                        <span>
                          <strong>Concession Type &nbsp;:</strong>
                        </span>
                        <span>&nbsp; {selectedBooking.purpose || "N/A"}</span>
                      </div>
                    </div>

                    {selectedBooking.file_url && (
                      <div className="row">
                        <div className="col-12">
                          <span>
                            <strong>Attachment of Proof &nbsp;:</strong>
                          </span>
                          <a href={selectedBooking.file_url} target="_blank">
                            &nbsp; view
                          </a>
                        </div>
                      </div>
                    )}

                    {/* Assigned to RI */}
                    <div className="row">
                      <div className="col-12">
                        <span>
                          <strong>Assigned to &nbsp;:</strong>
                        </span>
                        <span>
                          &nbsp; {selectedBooking.ri_value || "Not Assigned"}
                        </span>
                      </div>
                    </div>

                    {/* Checkbox Confirmation */}
                    <div className="form-check">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="confirmCheck"
                        checked={isChecked}
                        onChange={(e) => setIsChecked(e.target.checked)}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="confirmCheck"
                      >
                        I have checked and confirmed that the information is
                        correct .
                      </label>
                    </div>
                  </div>

                  {/* Modal Actions */}
                  <div className="modal-actions">
                    <button
                      onClick={() =>
                        handleApprove(selectedBooking.booking_group_id)
                      }
                      disabled={!isChecked}
                      className="approve-btn"
                    >
                      Approve
                    </button>
                    <button onClick={closeModal} className="cancel-btn">
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            )}

            <div className="col-lg-2"></div>
            <div className="pagination">
              <button
                className="btn-next-my"
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
              >
                Prev
              </button>
              <span
                style={{ paddingTop: "15px" }}
              >{`Page ${currentPage} of ${totalPageCount}`}</span>
              <button
                className="btn-next-my"
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPageCount}
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RIbookings;
